(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1842],{

/***/ 43412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* reexport */ Button_Button; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/common/Button/Button.module.scss
var Button_module = __webpack_require__(45432);
var Button_module_default = /*#__PURE__*/__webpack_require__.n(Button_module);
;// CONCATENATED MODULE: ./src/components/common/Button/Button.js
/* eslint-disable react/button-has-type */ 







function Button(_param) {
    var children = _param.children, onClick = _param.onClick, type = _param.type, className = _param.className, disabled = _param.disabled, variant = _param.variant, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "onClick",
        "type",
        "className",
        "disabled",
        "variant"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: classnames_default()((Button_module_default())[variant], (0,_define_property/* default */.Z)({}, className, !!className)),
        onClick: onClick,
        type: type,
        disabled: disabled
    }, restProps), {
        children: children
    }));
}
Button.propTypes = {
    children: prop_types_default().oneOfType([
        prop_types_default().arrayOf((prop_types_default()).node),
        (prop_types_default()).node
    ]),
    onClick: (prop_types_default()).func,
    type: prop_types_default().oneOf([
        "button",
        "submit",
        "reset"
    ]),
    className: (prop_types_default()).string,
    disabled: (prop_types_default()).bool,
    variant: prop_types_default().oneOf([
        "default",
        "plane",
        "empty"
    ])
};
Button.defaultProps = {
    children: "",
    onClick: function() {
        return null;
    },
    type: "button",
    className: "",
    disabled: false,
    variant: "default"
};
/* harmony default export */ var Button_Button = (Button);

;// CONCATENATED MODULE: ./src/components/common/Button/index.js
/* eslint-disable import/prefer-default-export */ 


/***/ }),

/***/ 84276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* reexport */ Dropdwon_Tooltip; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/common/Dropdwon/Tooltip.module.scss
var Tooltip_module = __webpack_require__(32710);
var Tooltip_module_default = /*#__PURE__*/__webpack_require__.n(Tooltip_module);
;// CONCATENATED MODULE: ./src/components/common/Dropdwon/Tooltip.js








function Tooltip(_param) {
    var children = _param.children, anchor = _param.anchor, className = _param.className, containerClassnaame = _param.containerClassnaame, show = _param.show, special = _param.special, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "anchor",
        "className",
        "containerClassnaame",
        "show",
        "special"
    ]);
    var positionClass;
    if (show === "center") {
        positionClass = (Tooltip_module_default()).showCenter;
    } else if (show === "right") {
        positionClass = (Tooltip_module_default()).showRight;
    } else {
        positionClass = (Tooltip_module_default()).showLeft;
    }
    var containerClassName = classnames_default()(positionClass, (Tooltip_module_default()).container, (0,_define_property/* default */.Z)({}, containerClassnaame, !!containerClassnaame));
    var tooltipClassName = classnames_default()(special === "newQuizPool" ? (Tooltip_module_default()).special : (Tooltip_module_default()).tooltip, (0,_define_property/* default */.Z)({}, className, !!className));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: containerClassName
    }, props), {
        children: [
            anchor,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: tooltipClassName,
                children: children
            })
        ]
    }));
}
Tooltip.propTypes = {
    anchor: prop_types_default().oneOfType([
        prop_types_default().arrayOf((prop_types_default()).node),
        (prop_types_default()).node
    ]),
    show: (prop_types_default()).string,
    special: (prop_types_default()).string,
    children: prop_types_default().oneOfType([
        prop_types_default().arrayOf((prop_types_default()).node),
        (prop_types_default()).node
    ]),
    className: (prop_types_default()).string,
    containerClassnaame: (prop_types_default()).string
};
Tooltip.defaultProps = {
    anchor: "",
    show: "",
    special: "",
    children: "",
    className: "",
    containerClassnaame: ""
};
/* harmony default export */ var Dropdwon_Tooltip = (Tooltip);

;// CONCATENATED MODULE: ./src/components/common/Dropdwon/index.js
/* eslint-disable import/prefer-default-export */ 


/***/ }),

/***/ 42268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function Loading() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        version: "1.1",
        id: "L4",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 100 100",
        enableBackground: "new 0 0 0 0",
        xmlSpace: "preserve",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                fill: "currentColor",
                stroke: "none",
                cx: "6",
                cy: "50",
                r: "6",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animate", {
                    attributeName: "opacity",
                    dur: "1s",
                    values: "0;1;0",
                    repeatCount: "indefinite",
                    begin: "0.1"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                fill: "currentColor",
                stroke: "none",
                cx: "26",
                cy: "50",
                r: "6",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animate", {
                    attributeName: "opacity",
                    dur: "1s",
                    values: "0;1;0",
                    repeatCount: "indefinite",
                    begin: "0.2"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                fill: "currentColor",
                stroke: "none",
                cx: "46",
                cy: "50",
                r: "6",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animate", {
                    attributeName: "opacity",
                    dur: "1s",
                    values: "0;1;0",
                    repeatCount: "indefinite",
                    begin: "0.3"
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Loading);


/***/ }),

/***/ 55047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Icons_useQRcode; }
});

;// CONCATENATED MODULE: ./src/components/common/Icons/downloadQrcode/a.png
/* harmony default export */ var a = ({"src":"/_next/static/media/a.46a8d1f9.png","height":500,"width":500,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAAs0lEQVR42g2O2w6CMBBE+5fGqNHE+KT+pokmKBIQuVR6hVJKoVjiq/uwm+zOTOag+zOPEmysa7V1k9dmeERFEOYoCLPLLRF1p/Qgm57y9hakUYxR149M6FdGC8yjuMixIEyNziOlLeFt8sa7zWK52mYlJaytlUEwFVWEysN+fTydcSW47HQ3ID//ZGMqpjAR5YeBD04uNQKGa5BCJ5MakwZe0AdsCHBBm75zbx3gwoaQm/wfpKGkAYHYyaIAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/common/Icons/downloadQrcode/b.png
/* harmony default export */ var b = ({"src":"/_next/static/media/b.57f0aca5.png","height":500,"width":500,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAAq0lEQVR42g1OWQrCQBSbM/oj6IeiiHhYUVq7Taevs3aWTpfRHsAHIYQQkpC6lZ8S1rQJ7f24oChqXlNB8hKeb2r91EsHwgG3r6xFk2DE+hmEzQqWl6zrh5LKOCUS4hLiWjVw2O9O5ysDyZUP40KwBBUDdbscb/eHNs7YiCZJ341LN9gIXCttlQnG4ocfKeoe19QwInCMdpr1ZowrqRpRUeHD4sPswoztyGva/gQNpMzTCYohAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/common/Icons/downloadQrcode/c.png
/* harmony default export */ var c = ({"src":"/_next/static/media/c.3bf69e78.png","height":500,"width":500,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAAsklEQVR42hWOSw6CMBRFu0zjwG+M+1QTjcFPREWUx699tKWlFGEBPgd3cgfnHBZc4+MpkrophXbt1/n+eH4Fl5gdgudmf0Nl00LyykAut/uQTua7QWoHWRU+4R5BkuEjLoz1jKaNT6CcT0eT2eIDZc51bVtG9LRQkPHlfLxcrQUqlJZOZl1HdCFNmiNHxbEuRd36np2u8e4QQl5xNCR7g0hS/DuolYq1aaVqiEB0pZ3vhh9JMaM/Cxd5RgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/common/Icons/downloadQrcode/d.png
/* harmony default export */ var d = ({"src":"/_next/static/media/d.1c42fa75.png","height":500,"width":500,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAAsklEQVR42hWO6QqCQBSF5yH7FUFEENF7FpW5hEvujrM5izpaPkBXuFwOnMP5DgrC0g2y0X4rLAhT07y4QR6EBXK89PqIlLZMmKLmcPdX4vgpggjveoiHSRUlZV6xOGt1b5EZJirMJ2t2283+cCxriqlaDcJ0Q2RetsfD9nS+MC6hoFMD6oe5xh0AMBFcKMo1aDv/kB8Wt2eMiaTcCDkAA/imn5D3XsdJPSpjtbHwQU/z8gdTGaNqxVnjCwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/common/Icons/downloadQrcode/e.png
/* harmony default export */ var e = ({"src":"/_next/static/media/e.440eeb1c.png","height":500,"width":500,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAAr0lEQVR42hWOyw6CMBBF+5lqjEa36me6QAMEAoJAKdAHpQ+giHvH5C7mce+cQWFcxim24yLVaEenzAwTPyrQM8zvXkK5GvTUMdXQ4RHkYEVgbOmQlV2JuzTDFeGkk7NbkTITeIuqPR+3u/0RClgIaRATuiKCtPx02FyuN0wo5VrpCS2fr5C2bvv4hWvCeG+o0IBEUVJ5fgYN6I0ZHEjz5p8IogIEOWMdMOFvALhl/QGdXaPhaDFaJgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/common/Icons/downloadQrcode/g.png
/* harmony default export */ var g = ({"src":"/_next/static/media/g.09713965.png","height":500,"width":500,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAAsklEQVR42h1O2wqCMBjeOwZBQV1K9YB1VRBFqZiEYloeptt00zmPPUC/wXfzf8cfHU7mxXCZqFU7UF7VTW/YPpBIf7yuphtmeUw45TImxVl3wIpk0zEhSVE+vTCI0pSJvKwBiFcKM+FHeKOt58uV44dvzMCKgE0oh3uxmGnbXZRSwmWlWtT2IwShwfskIIMXZqaqu+XdLK/pxzArADDmBBg0tD+apu2rbsiF/D8ypbvh+wORzKFwtV8KjwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/common/Icons/downloadQrcode/QRcode-en-US.png
/* harmony default export */ var QRcode_en_US = ({"src":"/_next/static/media/QRcode-en-US.e30dc871.png","height":1024,"width":1024,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAAtElEQVR42h2OSw6DIABEOVTXXXbTRQ/QNGmaNr2etjeAeACNiYA/QEAMgibqvtjZvsybAWmaQoiUUl3X2XEPhDDLMpAkSRRFGOOyqqSUhJA4jiFCQAjBGOtNT3EhOBuGITCtNdD/UEoPl9v58aKEWGvneQbTNHEuyrI8Xd/H+7NpmmVZAgPGGEIpY5zgwmgdxoN8Bwihz+fbtq333nlf1XWe51IqEJ4FNo5u27agdc6F0rquP6R2n/aBq2uCAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/common/Icons/downloadQrcode/QRcode-zh-CN.png
/* harmony default export */ var QRcode_zh_CN = ({"src":"/_next/static/media/QRcode-zh-CN.4487b358.png","height":1024,"width":1024,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAAtUlEQVR42hWOSw6CMBCGezA9gd7AxEQX7vRmAmeAuiY0oS8bSOjLQlIESdg6zGZmMf/3/agipCgK55yxdhgGY0yBMSEEYfx6JgljzDpnrW3bNk1TeEWfELqu6/v+LXhVlp3WQkrIoRij1ppzfrw89qezlHL8boN+y+K8o5QeLvfd9ea9DyEAE8EFi3HOaN0o1TQN50IbA3KcZZkQAuQ1pYBSSm0oaJbn+TRNcRyd9/M8g3Vd1z+YbJ9qda6LgwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/common/Icons/useQRcode.js








var QRcodes = {
    en: QRcode_en_US,
    zh: QRcode_zh_CN,
    a: a,
    b: b,
    c: c,
    d: d,
    e: e,
    g: g
};
var qrcodeList = {
    JsHgJj: "https://app.bs.inokn.com?t=bitop&b=a",
    MYVU3n: "https://app.bs.inokn.com?t=bitop&b=b",
    "6jPpWd": "https://app.bs.inokn.com?t=bitop&b=c",
    Ic5QiJ: "https://app.bs.inokn.com?t=bitop&b=d",
    rEyIQq: "https://app.bs.inokn.com?t=bitop&b=e",
    Qiy8p8: "https://app.bs.inokn.com?t=bitop&b=g"
};
var useQRcode = function(param) {
    var locale = param.locale, ru = param.ru;
    var url = qrcodeList[ru];
    if (url) {
        return {
            qrCode: QRcodes[url.slice(-1)],
            url: url
        };
    }
    return {
        qrCode: QRcodes[locale]
    };
};
/* harmony default export */ var Icons_useQRcode = (useQRcode);


/***/ }),

/***/ 50537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Portal_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26022);
/* harmony import */ var _Portal_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Portal_module_scss__WEBPACK_IMPORTED_MODULE_2__);




function Wrap(param) {
    var children = param.children, onClick = param.onClick, footer = param.footer, _className = param.className, className = _className === void 0 ? "" : _className, _opacity = param.opacity, opacity = _opacity === void 0 ? 0.5 : _opacity;
    var handleClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(param) {
        var currentTarget = param.currentTarget, target = param.target;
        var childNodes = currentTarget.childNodes;
        for(var i = 0; i < childNodes.length; i += 1){
            if (childNodes[i] === target) {
                onClick();
            }
        }
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Portal_module_scss__WEBPACK_IMPORTED_MODULE_2___default().overlay),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            onClick: handleClick,
            "aria-hidden": "true",
            className: (_Portal_module_scss__WEBPACK_IMPORTED_MODULE_2___default().modal),
            style: {
                backgroundColor: "rgba(0,0,0, ".concat(opacity, ")")
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "".concat((_Portal_module_scss__WEBPACK_IMPORTED_MODULE_2___default().content), " ").concat(className),
                    children: children
                }),
                footer && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("footer", {
                    className: (_Portal_module_scss__WEBPACK_IMPORTED_MODULE_2___default().footer),
                    children: footer
                })
            ]
        })
    });
}
function usePortal() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _closeOnOutSide = ref.closeOnOutSide, closeOnOutSide = _closeOnOutSide === void 0 ? null : _closeOnOutSide, _className = ref.className, className = _className === void 0 ? "" : _className, _defaultShow = ref.defaultShow, defaultShow = _defaultShow === void 0 ? false : _defaultShow, _defaultFailShow = ref.defaultFailShow, defaultFailShow = _defaultFailShow === void 0 ? false : _defaultFailShow, _opacity = ref.opacity, opacity = _opacity === void 0 ? 0.5 : _opacity;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(defaultShow), isShow = ref1[0], setShow = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(defaultFailShow), isFailShow = ref2[0], setFailShow = ref2[1];
    var PortalClose = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        document.body.classList.remove((_Portal_module_scss__WEBPACK_IMPORTED_MODULE_2___default().noScroll));
        setShow(false);
    }, []);
    var PortalFailClose = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        document.body.classList.remove((_Portal_module_scss__WEBPACK_IMPORTED_MODULE_2___default().noScroll));
        setFailShow(false);
    }, []);
    var PortalOpen = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        document.body.classList.add((_Portal_module_scss__WEBPACK_IMPORTED_MODULE_2___default().noScroll));
        setShow(true);
    }, []);
    var PortalFailOpen = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        document.body.classList.add((_Portal_module_scss__WEBPACK_IMPORTED_MODULE_2___default().noScroll));
        setFailShow(true);
    }, []);
    var Portal = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(param) {
        var children = param.children, footer = param.footer;
        if (!isShow) return null;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Wrap, {
            onClick: closeOnOutSide ? PortalClose : PortalOpen,
            className: className,
            footer: footer,
            opacity: opacity,
            children: children
        });
    }, [
        isShow,
        className,
        closeOnOutSide
    ]);
    var PortalFail = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(param) {
        var children = param.children, footer = param.footer;
        if (!isFailShow) return null;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Wrap, {
            onClick: closeOnOutSide ? PortalFailClose : PortalFailOpen,
            className: className,
            footer: footer,
            opacity: opacity,
            children: children
        });
    }, [
        isFailShow,
        className,
        closeOnOutSide
    ]);
    return {
        Portal: Portal,
        isShow: isShow,
        PortalClose: PortalClose,
        PortalOpen: PortalOpen,
        PortalFail: PortalFail,
        isFailShow: isFailShow,
        PortalFailClose: PortalFailClose,
        PortalFailOpen: PortalFailOpen
    };
}
Wrap.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().node),
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func),
    footer: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().node),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().node),
    opacity: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number)
};
Wrap.defaultProps = {
    children: "",
    onClick: function() {},
    footer: "",
    className: "",
    opacity: 0.5
};
/* harmony default export */ __webpack_exports__["Z"] = (usePortal);


/***/ }),

/***/ 43051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_api_sessionPass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55275);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28677);
/* harmony import */ var _ServicePlatformChoice_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86786);
/* harmony import */ var _ServicePlatformChoice_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ServicePlatformChoice_module_scss__WEBPACK_IMPORTED_MODULE_3__);





function ServicePlatformChoice(param) {
    var className = param.className, width = param.width, cross = param.cross, height = param.height, hideTitle = param.hideTitle, closeFunc = param.closeFunc;
    var handleRedirect = function handleRedirect(e) {
        var dataset = e.currentTarget.dataset;
        closeFunc();
        (0,_utils_api_sessionPass__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)("".concat(dataset.path, "#download"));
    };
    var ref = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("pages", {
        keyPrefix: "servicePlatformChoice"
    }), t = ref.t, i18n = ref.i18n;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "".concat((_ServicePlatformChoice_module_scss__WEBPACK_IMPORTED_MODULE_3___default().container), " ").concat(className || ""),
        style: {
            minWidth: width || "100%",
            maxHeight: height || "100%"
        },
        children: [
            cross && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_ServicePlatformChoice_module_scss__WEBPACK_IMPORTED_MODULE_3___default().cross),
                onKeyDown: closeFunc,
                onClick: closeFunc,
                role: "presentation",
                children: "X"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_ServicePlatformChoice_module_scss__WEBPACK_IMPORTED_MODULE_3___default().title),
                children: hideTitle ? "" : t("header")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_ServicePlatformChoice_module_scss__WEBPACK_IMPORTED_MODULE_3___default().content),
                children: t("bodyContent")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                style: {
                    display: hideTitle ? "flex" : "initial",
                    justifyContent: hideTitle ? "space-evenly" : "initial"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "".concat((_ServicePlatformChoice_module_scss__WEBPACK_IMPORTED_MODULE_3___default().btn)),
                        onClick: handleRedirect,
                        onKeyDown: handleRedirect,
                        "data-path": i18n.language === "en" ? "/en" : "/",
                        role: "presentation",
                        children: t("choice1")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "".concat((_ServicePlatformChoice_module_scss__WEBPACK_IMPORTED_MODULE_3___default().btn), " ").concat((_ServicePlatformChoice_module_scss__WEBPACK_IMPORTED_MODULE_3___default().btnFade)),
                        onKeyDown: handleRedirect,
                        onClick: handleRedirect,
                        "data-path": "/login",
                        role: "presentation",
                        children: t("choice2")
                    })
                ]
            })
        ]
    });
}
ServicePlatformChoice.propTypes = {
    className: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node),
    cross: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    closeFunc: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func),
    width: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    height: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    hideTitle: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool)
};
ServicePlatformChoice.defaultProps = {
    className: "",
    cross: false,
    closeFunc: function() {},
    width: "100%",
    height: "100%",
    hideTitle: false
};
/* harmony default export */ __webpack_exports__["Z"] = (ServicePlatformChoice);


/***/ }),

/***/ 81842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layout_MainLayout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 23 modules
var esm = __webpack_require__(28677);
// EXTERNAL MODULE: ./src/utils/store/index.js + 10 modules
var store = __webpack_require__(26721);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/api/sessionPass.js
var sessionPass = __webpack_require__(55275);
// EXTERNAL MODULE: ./node_modules/mobx-react/dist/mobxreact.esm.js + 17 modules
var mobxreact_esm = __webpack_require__(50828);
// EXTERNAL MODULE: ./src/utils/functions/common.js
var common = __webpack_require__(18942);
// EXTERNAL MODULE: ./config/appConfig.js
var appConfig = __webpack_require__(55925);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/index.mjs + 1 modules
var dist = __webpack_require__(86501);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/common/Icons/svg/Loading.js
var Loading = __webpack_require__(42268);
;// CONCATENATED MODULE: ./src/components/common/Icons/svg/Logo.js

function Logo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: "65.295",
        height: "33.295",
        viewBox: "0 0 65.295 33.295",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "linear2",
                    y1: "0.5",
                    x2: "1",
                    y2: "0.5",
                    gradientUnits: "objectBoundingBox",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "0",
                            stopColor: "#00a5ff"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "0.3",
                            stopColor: "#00cbfd"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "1",
                            stopColor: "#00f2ed"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                id: "Group_2",
                "data-name": "Group 2",
                transform: "translate(0.5 0.5)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    id: "Union_45",
                    "data-name": "Union 45",
                    d: "M48.893,32.3V16.1a7.657,7.657,0,0,1,.6-3,7.67,7.67,0,0,1,4.1-4.1,7.758,7.758,0,0,1,5.992,0,7.668,7.668,0,0,1,4.1,4.1,7.767,7.767,0,0,1,0,5.992,7.671,7.671,0,0,1-4.1,4.1,7.787,7.787,0,0,1-5.6.157,7.743,7.743,0,0,1-2.214-1.24V32.3Zm5.824-20.631a4.887,4.887,0,0,0-2.563,2.563,4.913,4.913,0,0,0,0,3.753,4.881,4.881,0,0,0,2.563,2.563A4.8,4.8,0,0,0,60,19.509a5.067,5.067,0,0,0,1.034-1.529,4.913,4.913,0,0,0,0-3.753A5.057,5.057,0,0,0,60,12.7a4.853,4.853,0,0,0-5.283-1.035ZM36.3,23.2a7.672,7.672,0,0,1-4.1-4.1,7.767,7.767,0,0,1,0-5.992,7.67,7.67,0,0,1,4.1-4.1,7.758,7.758,0,0,1,5.992,0,7.67,7.67,0,0,1,4.1,4.1,7.767,7.767,0,0,1,0,5.992,7.672,7.672,0,0,1-4.1,4.1,7.759,7.759,0,0,1-5.992,0Zm1.119-11.538a4.844,4.844,0,0,0-2.562,6.317,5.039,5.039,0,0,0,1.034,1.528,4.861,4.861,0,0,0,1.528,1.034,4.807,4.807,0,0,0,1.877.373,4.865,4.865,0,0,0,1.877-.373A5.042,5.042,0,0,0,42.7,19.509a4.882,4.882,0,0,0,1.023-1.528A4.834,4.834,0,0,0,42.7,12.7a5.058,5.058,0,0,0-1.528-1.035,4.866,4.866,0,0,0-1.877-.373A4.808,4.808,0,0,0,37.414,11.664ZM4.7,23.2A7.672,7.672,0,0,1,.6,19.1a7.658,7.658,0,0,1-.6-3V0H2.888V10.088A7.731,7.731,0,0,1,10.7,9.005a7.663,7.663,0,0,1,4.1,4.1,7.759,7.759,0,0,1,0,5.992,7.666,7.666,0,0,1-4.1,4.1,7.759,7.759,0,0,1-5.992,0ZM5.823,11.664A4.863,4.863,0,0,0,4.3,12.7a5.044,5.044,0,0,0-1.034,1.528,4.915,4.915,0,0,0,0,3.754A5.061,5.061,0,0,0,4.3,19.509a4.851,4.851,0,0,0,5.283,1.034A5.035,5.035,0,0,0,11.1,19.509a4.879,4.879,0,0,0,1.023-1.528,4.775,4.775,0,0,0,0-3.754A4.863,4.863,0,0,0,11.1,12.7a5.05,5.05,0,0,0-1.527-1.035,4.917,4.917,0,0,0-3.755,0ZM25.392,23.323V14.949l-1.167.674-1.443-2.5,2.611-1.5V6H28.28V9.944l1.167-.674,1.443,2.5-2.611,1.5V23.323Zm-7.489,0V9.848H20.79V23.323Zm.252-16.135a1.684,1.684,0,0,1,0-2.382A1.685,1.685,0,0,1,21.031,6a1.685,1.685,0,0,1-2.876,1.191Z",
                    transform: "translate(0 0)",
                    stroke: "rgba(0,0,0,0)",
                    strokeWidth: "1",
                    fill: "url(#linear2)"
                })
            })
        ]
    });
}
/* harmony default export */ var svg_Logo = (Logo);

// EXTERNAL MODULE: ./src/components/common/Button/index.js + 1 modules
var Button = __webpack_require__(43412);
// EXTERNAL MODULE: ./src/components/common/Dropdwon/index.js + 1 modules
var Dropdwon = __webpack_require__(84276);
// EXTERNAL MODULE: ./src/components/common/Icons/useQRcode.js + 8 modules
var useQRcode = __webpack_require__(55047);
// EXTERNAL MODULE: ./src/components/common/ServicePlatformChoice/ServicePlatformChoice.js
var ServicePlatformChoice = __webpack_require__(43051);
// EXTERNAL MODULE: ./src/components/common/Modal/Portal.js
var Modal_Portal = __webpack_require__(50537);
// EXTERNAL MODULE: ./src/utils/hooks/quizPool/usePoolListData.js
var usePoolListData = __webpack_require__(65946);
// EXTERNAL MODULE: ./src/utils/hooks/useH5StringBuilder.js
var useH5StringBuilder = __webpack_require__(82807);
;// CONCATENATED MODULE: ./src/layout/header/icons/ProfileIcon.js

function ProfileIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: "48px",
        height: "64px",
        viewBox: "0 0 48 64",
        version: "1.1",
        className: "injected-svg",
        "data-src": "/static/media/User.0fe1ccc0.svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                id: "Icons-/-Systems-/-Header-/-User",
                stroke: "currentColor",
                strokeWidth: "1",
                fillRule: "evenodd",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M24,23 C28.9705627,23 33,27.0294373 33,32 C33,34.4908289 31.9881385,36.7453248 30.3530454,38.3748581 L30.3234782,38.4111165 C28.69417,40.0109541 26.462587,41 24,41 C19.0294373,41 15,36.9705627 15,32 C15,27.0294373 19.0294373,23 24,23 Z M27.856,36.495 L20.675,36.495 L18.4193685,38.0080879 C19.8830045,39.3682126 21.8443651,40.2 24,40.2 C26.2056114,40.2 28.2078359,39.329197 29.6816245,37.9126398 L27.856,36.495 Z M24,23.8 C19.4712651,23.8 15.8,27.4712651 15.8,32 C15.8,34.0799588 16.5744108,35.9790442 17.8506322,37.4246562 L20.3311459,35.7629111 C20.3750579,35.7334888 20.4241389,35.713209 20.4754727,35.7029583 L20.5537986,35.6952148 L27.9939415,35.6952148 C28.0531819,35.6952148 28.1112979,35.7083656 28.1642532,35.7332836 L28.2393109,35.7793132 L30.2337028,37.3276133 C31.4596251,35.8945511 32.2,34.0337375 32.2,32 C32.2,27.4712651 28.5287349,23.8 24,23.8 Z M24,27 C25.9329966,27 27.5,28.5670034 27.5,30.5 C27.5,32.4329966 25.9329966,34 24,34 C22.0670034,34 20.5,32.4329966 20.5,30.5 C20.5,28.5670034 22.0670034,27 24,27 Z M24,27.8 C22.5088312,27.8 21.3,29.0088312 21.3,30.5 C21.3,31.9911688 22.5088312,33.2 24,33.2 C25.4911688,33.2 26.7,31.9911688 26.7,30.5 C26.7,29.0088312 25.4911688,27.8 24,27.8 Z",
                    id: "Combined-Shape",
                    fillRule: "nonzero"
                })
            })
        ]
    });
}
/* harmony default export */ var icons_ProfileIcon = (ProfileIcon);

;// CONCATENATED MODULE: ./src/layout/header/icons/DownLoadIcon.js

function DownLoadIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3 14L3.23384 14.6626C4.144 17.2413 4.59908 18.5307 5.63742 19.2654C6.67576 20 8.0431 20 10.7778 20H13.2222C15.9569 20 17.3242 20 18.3626 19.2654C19.4009 18.5307 19.856 17.2413 20.7662 14.6626L21 14",
                stroke: "white",
                strokeWidth: "1.5",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 14V4M12 14C11.2998 14 9.99153 12.0057 9.5 11.5M12 14C12.7002 14 14.0085 12.0057 14.5 11.5",
                stroke: "white",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}
/* harmony default export */ var icons_DownLoadIcon = (DownLoadIcon);

;// CONCATENATED MODULE: ./src/layout/header/icons/LanguageIcon.js

function LanguageIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.99996 18.3334C14.6023 18.3334 18.3333 14.6025 18.3333 10.0001C18.3333 5.39771 14.6023 1.66675 9.99996 1.66675C5.39759 1.66675 1.66663 5.39771 1.66663 10.0001C1.66663 14.6025 5.39759 18.3334 9.99996 18.3334Z",
                stroke: "#E2E2E3",
                strokeWidth: "0.8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.66663 10.0001C6.66663 15.0001 9.99996 18.3334 9.99996 18.3334C9.99996 18.3334 13.3333 15.0001 13.3333 10.0001C13.3333 5.00008 9.99996 1.66675 9.99996 1.66675C9.99996 1.66675 6.66663 5.00008 6.66663 10.0001Z",
                stroke: "#E2E2E3",
                strokeWidth: "0.8",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.5 12.5H2.5",
                stroke: "#E2E2E3",
                strokeWidth: "0.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.5 7.5H2.5",
                stroke: "#E2E2E3",
                strokeWidth: "0.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}
/* harmony default export */ var icons_LanguageIcon = (LanguageIcon);

;// CONCATENATED MODULE: ./src/layout/header/icons/MarketsIcon.js

function MarketsIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 18 16.188",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            id: "Group_5253",
            "data-name": "Group 5253",
            transform: "translate(872.742 -22293.57)",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                id: "Group_5252",
                "data-name": "Group 5252",
                transform: "translate(-872.242 22294.07)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Path_3811",
                        "data-name": "Path 3811",
                        d: "M-866.242,22321.865h17",
                        transform: "translate(866.242 -22306.678)",
                        fill: "none",
                        stroke: "currentColor",
                        strokeLinecap: "round",
                        strokeWidth: "1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Path_3812",
                        "data-name": "Path 3812",
                        d: "M-866.242,22197.361h6.108V22185.1h-6.108Z",
                        transform: "translate(867.393 -22185.104)",
                        fill: "none",
                        stroke: "currentColor",
                        strokeLinecap: "round",
                        strokeWidth: "1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Path_3813",
                        "data-name": "Path 3813",
                        d: "M-866.242,22193.615h6.108v-8.512h-6.108Z",
                        transform: "translate(875.983 -22181.357)",
                        fill: "none",
                        stroke: "currentColor",
                        strokeLinecap: "round",
                        strokeWidth: "1"
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var icons_MarketsIcon = (MarketsIcon);

;// CONCATENATED MODULE: ./src/layout/header/icons/TradeIcon.js

function TradeIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16.958 16.645",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            id: "Group_4837",
            "data-name": "Group 4837",
            transform: "translate(13651.72 -10793)",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    id: "Path_2384",
                    "data-name": "Path 2384",
                    d: "M-13631.5,10808.734v-2.355h-3.263v-11.755h3.263v0h2.736v11.755h-2.736Z",
                    transform: "translate(-6.498 0.91)",
                    fill: "none",
                    stroke: "currentColor",
                    strokeLinecap: "round",
                    strokeWidth: "1"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    id: "Path_2385",
                    "data-name": "Path 2385",
                    d: "M-13631.155,10808.374v-2.735h-3.147v-9.052h3.147v0h2.853v9.052h-2.853Z",
                    transform: "translate(-16.917 1.271)",
                    fill: "none",
                    stroke: "currentColor",
                    strokeLinecap: "round",
                    strokeWidth: "1"
                })
            ]
        })
    });
}
/* harmony default export */ var icons_TradeIcon = (TradeIcon);

;// CONCATENATED MODULE: ./src/layout/header/icons/BuyCrypto.js

function BuyCryptoIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 18 17",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            id: "BytesizeCart",
            transform: "translate(-1.5 -1.5)",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    id: "Path_3810",
                    "data-name": "Path 3810",
                    d: "M4.429,4.1H19L17.179,10.9H6.25M17.179,13H6.857L3.821,2H2",
                    fill: "none",
                    stroke: "currentColor",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "1"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    id: "Ellipse_522",
                    "data-name": "Ellipse 522",
                    cx: "1.5",
                    cy: "1.5",
                    r: "1.5",
                    transform: "translate(13 15)",
                    fill: "none",
                    stroke: "currentColor",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "1"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    id: "Ellipse_523",
                    "data-name": "Ellipse 523",
                    cx: "1.5",
                    cy: "1.5",
                    r: "1.5",
                    transform: "translate(6.333 15)",
                    fill: "none",
                    stroke: "currentColor",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "1"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("text", {
                    id: "_",
                    "data-name": "$",
                    transform: "translate(9 4)",
                    fill: "#e7e9ec",
                    fontSize: "5",
                    fontFamily: "IBMPlexSans, IBM Plex Sans",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tspan", {
                        x: "-1",
                        y: "5",
                        children: "$"
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var BuyCrypto = (BuyCryptoIcon);

;// CONCATENATED MODULE: ./src/layout/header/icons/Support.js

function SupportIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            id: "BytesizeMessage",
            d: "M2,4H19V16.24H10.5L5.643,21V16.24H2Z",
            transform: "translate(-1.5 -3.5)",
            fill: "none",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "1"
        })
    });
}
/* harmony default export */ var Support = (SupportIcon);

;// CONCATENATED MODULE: ./src/layout/header/icons/QuizPool.js

function QuizPoolIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "2 2 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4 11V15C4 18.2998 4 19.9497 5.02513 20.9749C6.05025 22 7.70017 22 11 22H13C16.2998 22 17.9497 22 18.9749 20.9749C20 19.9497 20 18.2998 20 15V11",
                stroke: "#E2E2E3",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3 9C3 8.25231 3 7.87846 3.20096 7.6C3.33261 7.41758 3.52197 7.26609 3.75 7.16077C4.09808 7 4.56538 7 5.5 7H18.5C19.4346 7 19.9019 7 20.25 7.16077C20.478 7.26609 20.6674 7.41758 20.799 7.6C21 7.87846 21 8.25231 21 9C21 9.74769 21 10.1215 20.799 10.4C20.6674 10.5824 20.478 10.7339 20.25 10.8392C19.9019 11 19.4346 11 18.5 11H5.5C4.56538 11 4.09808 11 3.75 10.8392C3.52197 10.7339 3.33261 10.5824 3.20096 10.4C3 10.1215 3 9.74769 3 9Z",
                stroke: "#E2E2E3",
                strokeWidth: "1.5",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6 3.78571C6 2.79949 6.79949 2 7.78571 2H8.14286C10.2731 2 12 3.7269 12 5.85714V7H9.21429C7.43908 7 6 5.56091 6 3.78571Z",
                stroke: "#E2E2E3",
                strokeWidth: "1.5",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18 3.78571C18 2.79949 17.2005 2 16.2143 2H15.8571C13.7269 2 12 3.7269 12 5.85714V7H14.7857C16.5609 7 18 5.56091 18 3.78571Z",
                stroke: "#E2E2E3",
                strokeWidth: "1.5",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 11V22",
                stroke: "#E2E2E3",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}
/* harmony default export */ var QuizPool = (QuizPoolIcon);

;// CONCATENATED MODULE: ./src/layout/header/icons/More.js

function MoreIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "6",
        viewBox: "0 0 18 5",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            id: "BytesizeEllipsisHorizontal",
            transform: "translate(-4.5 -13.5)",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    id: "Ellipse_524",
                    "data-name": "Ellipse 524",
                    cx: "2",
                    cy: "2",
                    r: "2",
                    transform: "translate(5 14)",
                    fill: "none",
                    stroke: "currentColor",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "1"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    id: "Ellipse_525",
                    "data-name": "Ellipse 525",
                    cx: "2",
                    cy: "2",
                    r: "2",
                    transform: "translate(11.5 14)",
                    fill: "none",
                    stroke: "currentColor",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "1"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    id: "Ellipse_526",
                    "data-name": "Ellipse 526",
                    cx: "2",
                    cy: "2",
                    r: "2",
                    transform: "translate(18 14)",
                    fill: "none",
                    stroke: "currentColor",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "1"
                })
            ]
        })
    });
}
/* harmony default export */ var More = (MoreIcon);

// EXTERNAL MODULE: ./src/layout/header/icons/Bitop.js
var Bitop = __webpack_require__(40822);
;// CONCATENATED MODULE: ./src/layout/header/icons/Hamburger.js

function Hamburger() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 18.736 10.693",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            id: "Group_4719",
            "data-name": "Group 4719",
            transform: "translate(-318.225 -35.514)",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    id: "Path_2267",
                    "data-name": "Path 2267",
                    d: "M17434.223,16042.859h18.736",
                    transform: "translate(-17115.998 -16006.846)",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "1"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    id: "Path_2268",
                    "data-name": "Path 2268",
                    d: "M17434.223,16042.859h18.736",
                    transform: "translate(-17115.998 -15997.152)",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "1"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    id: "Path_2269",
                    "data-name": "Path 2269",
                    d: "M17434.223,16042.859h18.736",
                    transform: "translate(-17115.998 -16002)",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "1"
                })
            ]
        })
    });
}
/* harmony default export */ var icons_Hamburger = (Hamburger);

;// CONCATENATED MODULE: ./src/layout/header/icons/UnAuthIcon.js

function UnAuthIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "10px",
        height: "10px",
        viewBox: "0 0 10 10",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            id: "Icons-/-Systems-/-User-/-Unverified",
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                    id: "星形",
                    fill: "#777E90",
                    points: "5 9.04622396 3.45491503 9.75528258 2.62168923 8.27346395 0.954915028 7.93892626 1.15181234 6.25035197 0 5 1.15181234 3.74964803 0.954915028 2.06107374 2.62168923 1.72653605 3.45491503 0.244717419 5 0.953776042 6.54508497 0.244717419 7.37831077 1.72653605 9.04508497 2.06107374 8.84818766 3.74964803 10 5 8.84818766 6.25035197 9.04508497 7.93892626 7.37831077 8.27346395 6.54508497 9.75528258"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M5,6.66666667 C5.3681898,6.66666667 5.66666667,6.96514353 5.66666667,7.33333333 C5.66666667,7.70152313 5.3681898,8 5,8 C4.63181017,8 4.33333333,7.70152313 4.33333333,7.33333333 C4.33333333,6.96514353 4.63181017,6.66666667 5,6.66666667 Z M5,2 C5.3681898,2 5.66666667,2.23451751 5.66666667,2.52380952 L5.66666667,5.14285714 C5.66666667,5.43214913 5.3681898,5.66666667 5,5.66666667 C4.63181017,5.66666667 4.33333333,5.43214913 4.33333333,5.14285714 L4.33333333,2.52380952 C4.33333333,2.23451751 4.63181017,2 5,2 Z",
                    id: "Combined-Shape",
                    fill: "#28282B",
                    fillRule: "nonzero"
                })
            ]
        })
    });
}
/* harmony default export */ var icons_UnAuthIcon = (UnAuthIcon);

;// CONCATENATED MODULE: ./src/layout/header/icons/AdvanceAuthIcon.js

function AdvanceAuthIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "10px",
        height: "10px",
        viewBox: "0 0 10 10",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            id: "Icons-/-Systems-/-User-/-High-Verify",
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                    id: "星形",
                    fill: "#FFD140",
                    points: "5 9.04622396 3.45491503 9.75528258 2.62168923 8.27346395 0.954915028 7.93892626 1.15181234 6.25035197 0 5 1.15181234 3.74964803 0.954915028 2.06107374 2.62168923 1.72653605 3.45491503 0.244717419 5 0.953776042 6.54508497 0.244717419 7.37831077 1.72653605 9.04508497 2.06107374 8.84818766 3.74964803 10 5 8.84818766 6.25035197 9.04508497 7.93892626 7.37831077 8.27346395 6.54508497 9.75528258"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M6.77683715,3.47764018 L4.28920896,5.8297765 L3.21661887,4.85040499 C3.01165203,4.663242 2.68624973,4.66670279 2.48577961,4.85674978 L2.4797317,4.86256721 C2.27964502,5.05848106 2.28539664,5.37043037 2.49243755,5.55947207 L3.90590702,6.85011721 C3.97207101,6.91071907 4.05410891,6.95356837 4.14358839,6.97426081 C4.32523502,7.03202309 4.53387942,6.99248765 4.67859367,6.85565448 L7.51400319,4.1746604 C7.71752341,3.98222382 7.71752341,3.67022508 7.51400319,3.47780498 C7.31030868,3.28520359 6.98035737,3.28520359 6.77683715,3.47764018 Z",
                    id: "路径",
                    fill: "#141416"
                })
            ]
        })
    });
}
/* harmony default export */ var icons_AdvanceAuthIcon = (AdvanceAuthIcon);

;// CONCATENATED MODULE: ./src/layout/header/icons/CrossIcon.js

function CrossIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16px",
        height: "16px",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M20 20L4 4.00003M20 4L4.00002 20",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round"
        })
    });
}
/* harmony default export */ var icons_CrossIcon = (CrossIcon);

;// CONCATENATED MODULE: ./src/layout/header/icons/Logout.js

function LogoutIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16px",
        height: "16px",
        viewBox: "0 0 18 18",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M5.76,17.5H1.29c-.42,0-.76-.34-.76-.76V1.26c0-.42.34-.76.76-.76h4.47"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                        fill: "none",
                        stroke: "currentColor",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        x1: "4.81",
                        y1: "9",
                        x2: "17.48",
                        y2: "9"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("polyline", {
                        fill: "none",
                        stroke: "currentColor",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        points: "13.29 13.54 17.48 9 13.29 4.46"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var Logout = (LogoutIcon);

;// CONCATENATED MODULE: ./src/layout/header/icons/oldVersion.js

function OldVersionIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16px",
        height: "16px",
        viewBox: "0 0 18 18",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("polyline", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                points: "8.28 11.79 11.27 9 8.28 6.21"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M9,.53c4.68,0,8.47,3.79,8.47,8.47s-3.79,8.47-8.47,8.47S.53,13.68.53,9h10.03"
            })
        ]
    });
}
/* harmony default export */ var oldVersion = (OldVersionIcon);

;// CONCATENATED MODULE: ./src/layout/header/icons/PhoneIcon.js

function PhoneIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "23",
        height: "23",
        viewBox: "0 0 23 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.90527 8.74992C4.90527 5.72507 4.90527 4.21265 5.84498 3.27295C6.78467 2.33325 8.2971 2.33325 11.3219 2.33325C14.3468 2.33325 15.8592 2.33325 16.7989 3.27295C17.7386 4.21265 17.7386 5.72507 17.7386 8.74992V14.2499C17.7386 17.2747 17.7386 18.7871 16.7989 19.7269C15.8592 20.6666 14.3468 20.6666 11.3219 20.6666C8.2971 20.6666 6.78467 20.6666 5.84498 19.7269C4.90527 18.7871 4.90527 17.2747 4.90527 14.2499V8.74992Z",
                stroke: "white",
                strokeWidth: "1.5",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.4053 17.9167H12.2386",
                stroke: "white",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.5719 2.33325L8.65348 2.82277C8.83029 3.8836 8.91869 4.41402 9.28249 4.73679C9.662 5.07348 10.2 5.08325 11.3219 5.08325C12.4438 5.08325 12.9818 5.07348 13.3613 4.73679C13.7251 4.41402 13.8135 3.8836 13.9903 2.82277L14.0719 2.33325",
                stroke: "white",
                strokeWidth: "1.5",
                strokeLinejoin: "round"
            })
        ]
    });
}
/* harmony default export */ var icons_PhoneIcon = (PhoneIcon);

// EXTERNAL MODULE: ./src/layout/header/MainHeader.module.scss
var MainHeader_module = __webpack_require__(19804);
var MainHeader_module_default = /*#__PURE__*/__webpack_require__.n(MainHeader_module);
;// CONCATENATED MODULE: ./src/layout/header/MainHeader.js
/* eslint-disable react/no-danger */ /* eslint-disable no-plusplus */ /* eslint-disable react/no-unstable-nested-components */ /* eslint-disable object-curly-newline */ /* eslint-disable react/prop-types */ /* eslint-disable max-len */ 





























// import CopyTradeIcon from './icons/CopyTrade';












var userNameCover = function(userName) {
    if (typeof userName !== "string") return userName;
    var visableCharNum = Math.trunc(userName.length / 4);
    return userName.split("").fill("*", visableCharNum, userName.length - visableCharNum).join("");
};
var routeFunction = function(param) {
    var route = param.route, router = param.router, user = param.user, t = param.t, i18n = param.i18n, phrase = param.phrase, referral = param.referral;
    var langUrl = "";
    if (i18n.language === "en") {
        langUrl = "/en";
    }
    switch(route){
        case "login":
            if ((0,common/* getPlatform */.Xf)() === "pad" || (0,common/* getPlatform */.Xf)() === "pc") {
                (0,sessionPass/* default */.ZP)("/login");
            } else {
                (0,sessionPass/* default */.ZP)("".concat(phrase, "/login/login").concat(referral));
            }
            break;
        case "register":
            if ((0,common/* getPlatform */.Xf)() === "pad" || (0,common/* getPlatform */.Xf)() === "pc") {
                (0,sessionPass/* default */.ZP)("/register");
            } else {
                (0,sessionPass/* default */.ZP)("".concat(phrase, "/login/reg").concat(referral));
            }
            break;
        case "markets":
            if ((0,common/* getPlatform */.Xf)() === "pad" || (0,common/* getPlatform */.Xf)() === "pc") {
                router.push("/markets");
            } else {
                router.push("/markets");
            }
            break;
        case "spot":
            if ((0,common/* getPlatform */.Xf)() === "pad" || (0,common/* getPlatform */.Xf)() === "pc") {
                if (user) {
                    (0,sessionPass/* default */.ZP)("/trade/spot/BTCUSDT_CC");
                } else {
                    router.push("".concat(langUrl, "/trade/spotV2/BTCUSDT_CC"));
                }
            } else {
                (0,sessionPass/* default */.ZP)("".concat(phrase, "/spotQuote/BTCUSDT_CC").concat(referral));
            }
            break;
        case "margin":
            if ((0,common/* getPlatform */.Xf)() === "pad" || (0,common/* getPlatform */.Xf)() === "pc") {
                if (user) {
                    (0,sessionPass/* default */.ZP)("/trade/deal/BTCUSDT");
                } else {
                    router.push("/trade/margin/BTCUSDT");
                }
            } else {
                (0,sessionPass/* default */.ZP)("".concat(phrase, "/trade/BTCUSDT").concat(referral));
            }
            break;
        case "bitcast":
            if ((0,common/* getPlatform */.Xf)() === "pad" || (0,common/* getPlatform */.Xf)() === "pc") {
                if (user) {
                    (0,sessionPass/* default */.ZP)("/trade/game/BTCUSDT");
                } else {
                    router.push("/trade/bitcast/BTCUSDT");
                }
            } else {
                (0,sessionPass/* default */.ZP)("".concat(phrase, "/bitcast/BTCUSDT").concat(referral));
            }
            break;
        case "thirdParty":
            if ((0,common/* getPlatform */.Xf)() === "pad" || (0,common/* getPlatform */.Xf)() === "pc") {
                router.push("/trade/bitcast/BTCUSDT");
            } else {
                (0,sessionPass/* default */.ZP)("".concat(phrase, "/deposit/0").concat(referral));
            }
            break;
        case "c2c":
            if ((0,common/* getPlatform */.Xf)() === "pad" || (0,common/* getPlatform */.Xf)() === "pc") {
                if (user) {
                    (0,sessionPass/* default */.ZP)("/c2c");
                } else {
                    router.push("/download");
                }
            } else {
                (0,sessionPass/* default */.ZP)("".concat(phrase, "/deposit/0").concat(referral));
            }
            break;
        case "copyTrade":
            if ((0,common/* getPlatform */.Xf)() === "pad" || (0,common/* getPlatform */.Xf)() === "pc") {
                (0,sessionPass/* default */.ZP)("/trade/follow");
            } else {
                (0,sessionPass/* default */.ZP)("".concat(phrase, "/myFollow").concat(referral));
            }
            break;
        case "announcement":
            if ((0,common/* getPlatform */.Xf)() === "pad" || (0,common/* getPlatform */.Xf)() === "pc") {
                router.push("/news/announcement");
            } else {
                router.push("/news/announcement");
            }
            break;
        case "helpCenter":
            if ((0,common/* getPlatform */.Xf)() === "pad" || (0,common/* getPlatform */.Xf)() === "pc") {
                router.push("/helpCenter/beginnerGuide");
            } else {
                router.push("/helpCenter/beginnerGuide");
            }
            break;
        case "legalCenter":
            if ((0,common/* getPlatform */.Xf)() === "pad" || (0,common/* getPlatform */.Xf)() === "pc") {
                router.push("/legalCenter/termsOfService");
            } else {
                router.push("/legalCenter/termsOfService");
            }
            break;
        case "agent":
            if ((0,common/* getPlatform */.Xf)() === "pad" || (0,common/* getPlatform */.Xf)() === "pc") {
                (0,sessionPass/* default */.ZP)("/trade/agent/agent");
            } else {
                (0,sessionPass/* default */.ZP)("".concat(phrase, "/inviteRebate").concat(referral));
            }
            break;
        case "exchange":
            if ((0,common/* getPlatform */.Xf)() === "pad" || (0,common/* getPlatform */.Xf)() === "pc") {
                (0,sessionPass/* default */.ZP)("/trade/fastChange");
            } else {
                (0,sessionPass/* default */.ZP)("".concat(phrase, "/exchange").concat(referral));
            }
            break;
        case "news":
            if ((0,common/* getPlatform */.Xf)() === "pad" || (0,common/* getPlatform */.Xf)() === "pc") {
                router.push("/news/stories");
            } else {
                router.push("/news/stories");
            }
            break;
        case "eventCenter":
            if ((0,common/* getPlatform */.Xf)() === "pad" || (0,common/* getPlatform */.Xf)() === "pc") {
                router.push("/eventCenter");
            } else {
                (0,sessionPass/* default */.ZP)("".concat(phrase, "/eventCenter").concat(referral));
            }
            break;
        case "quizPool":
            {
                var now = new Date(); // date now
                var start = 1713801600000; // 2024-04-23 00:00:00
                var distance = start - now.getTime();
                var tempHours = Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
                var tempMinutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
                var tempSeconds = Math.floor(distance % (1000 * 60) / 1000);
                var countDownErr = t("nav.quizPool.countDownErr", {
                    h: tempHours,
                    m: tempMinutes,
                    s: tempSeconds
                });
                if (start < now) {
                    if ((0,common/* getPlatform */.Xf)() === "pad" || (0,common/* getPlatform */.Xf)() === "pc") {
                        router.push("/quizPool");
                    } else {
                        router.push("/quizPool");
                    }
                } else {
                    dist/* toast.error */.Am.error(countDownErr, {
                        id: "countDownErr"
                    });
                }
                break;
            }
        case "download":
            if ((0,common/* getPlatform */.Xf)() === "pad" || (0,common/* getPlatform */.Xf)() === "pc") {
                router.push("/download");
            } else {
                router.push("/download");
            }
            break;
        default:
            if ((0,common/* getPlatform */.Xf)() === "pad" || (0,common/* getPlatform */.Xf)() === "pc") {
                (0,sessionPass/* default */.ZP)("/trade/deal/BTCUSDT");
            } else {
                (0,sessionPass/* default */.ZP)("".concat(phrase).concat(referral));
            }
    }
};
function Mobile(param) {
    var router = param.router, t = param.t, i18n = param.i18n, setLanguage = param.setLanguage, user = param.user, logout = param.logout;
    var ref = (0,react.useState)(false), hamburg = ref[0], setHamburg = ref[1];
    var ref1 = (0,useH5StringBuilder/* default */.Z)(), phrase = ref1.phrase, referral = ref1.referral;
    var handleLocaleChange = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(locale) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            setLanguage(locale)
                        ];
                    case 1:
                        _state.sent();
                        router.replace(router.asPath, router.asPath, {
                            locale: locale
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function(locale) {
            return _ref.apply(this, arguments);
        };
    }(), [
        router
    ]);
    var langUrl = "";
    if (i18n.language === "en") {
        langUrl = "/en";
    }
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (MainHeader_module_default()).mobile,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (MainHeader_module_default()).nav,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "".concat(langUrl, "/"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Bitop/* default */.Z, {})
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: (MainHeader_module_default()).functionality,
                children: [
                    !user && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (MainHeader_module_default()).login,
                        onClick: function() {
                            return routeFunction({
                                route: "login",
                                router: router,
                                i18n: i18n,
                                user: user,
                                phrase: phrase,
                                referral: referral
                            });
                        },
                        onKeyUp: function(e) {
                            if (e.key === "Enter" || e.key === "Space") routeFunction({
                                route: "login",
                                router: router,
                                i18n: i18n,
                                user: user,
                                phrase: phrase,
                                referral: referral
                            });
                        },
                        role: "button",
                        tabIndex: 0,
                        children: t("login/register")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onClick: function() {
                            return setHamburg(true);
                        },
                        onKeyUp: function(e) {
                            if (e.key === "Enter" || e.key === "Space") setHamburg(true);
                        },
                        role: "button",
                        tabIndex: 0,
                        "aria-label": "Menu",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Hamburger, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((0,_define_property/* default */.Z)({}, (MainHeader_module_default()).open, hamburg), (MainHeader_module_default()).overlay),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (MainHeader_module_default()).hamburgerMenu,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (MainHeader_module_default()).cross,
                            onClick: function() {
                                return setHamburg(false);
                            },
                            onKeyUp: function(e) {
                                if (e.key === "Enter" || e.key === "Space") setHamburg(false);
                            },
                            role: "button",
                            tabIndex: 0,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_CrossIcon, {})
                        }),
                        !user && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (MainHeader_module_default()).btns,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (MainHeader_module_default()).login,
                                    role: "button",
                                    onClick: function() {
                                        return routeFunction({
                                            route: "login",
                                            router: router,
                                            i18n: i18n,
                                            user: user,
                                            phrase: phrase,
                                            referral: referral
                                        });
                                    },
                                    onKeyUp: function(e) {
                                        if (e.key === "Enter" || e.key === "Space") routeFunction({
                                            route: "login",
                                            router: router,
                                            i18n: i18n,
                                            user: user,
                                            phrase: phrase,
                                            referral: referral
                                        });
                                    },
                                    tabIndex: 0,
                                    children: t("login")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (MainHeader_module_default()).register,
                                    role: "button",
                                    onClick: function() {
                                        return routeFunction({
                                            route: "register",
                                            router: router,
                                            i18n: i18n,
                                            user: user,
                                            phrase: phrase,
                                            referral: referral
                                        });
                                    },
                                    onKeyUp: function(e) {
                                        if (e.key === "Enter" || e.key === "Space") routeFunction({
                                            route: "register",
                                            router: router,
                                            i18n: i18n,
                                            user: user,
                                            phrase: phrase,
                                            referral: referral
                                        });
                                    },
                                    tabIndex: 0,
                                    children: t("register")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()((MainHeader_module_default()).routeCon, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (MainHeader_module_default()).loggedIn, user), (0,_define_property/* default */.Z)(_obj, "phrase", phrase), (0,_define_property/* default */.Z)(_obj, "referral", referral), _obj)),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (MainHeader_module_default()).route,
                                    role: "button",
                                    onClick: function() {
                                        return routeFunction({
                                            route: "markets",
                                            router: router,
                                            i18n: i18n,
                                            user: user,
                                            phrase: phrase,
                                            referral: referral
                                        });
                                    },
                                    onKeyUp: function(e) {
                                        if (e.key === "Enter" || e.key === "Space") routeFunction({
                                            route: "markets",
                                            router: router,
                                            i18n: i18n,
                                            user: user,
                                            phrase: phrase,
                                            referral: referral
                                        });
                                    },
                                    tabIndex: 0,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_MarketsIcon, {}),
                                        t("nav.markets.title")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("details", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("summary", {
                                            className: (MainHeader_module_default()).route,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_TradeIcon, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: t("nav.trade.title")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (MainHeader_module_default()).subroute,
                                            role: "button",
                                            onClick: function() {
                                                return routeFunction({
                                                    route: "spot",
                                                    router: router,
                                                    i18n: i18n,
                                                    user: user,
                                                    phrase: phrase,
                                                    referral: referral
                                                });
                                            },
                                            onKeyUp: function(e) {
                                                if (e.key === "Enter" || e.key === "Space") routeFunction({
                                                    route: "spot",
                                                    router: router,
                                                    i18n: i18n,
                                                    user: user,
                                                    phrase: phrase,
                                                    referral: referral
                                                });
                                            },
                                            tabIndex: 0,
                                            children: t("nav.trade.dropDown.main1")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (MainHeader_module_default()).subroute,
                                            role: "button",
                                            onClick: function() {
                                                return routeFunction({
                                                    route: "margin",
                                                    router: router,
                                                    i18n: i18n,
                                                    user: user,
                                                    phrase: phrase,
                                                    referral: referral
                                                });
                                            },
                                            onKeyUp: function(e) {
                                                if (e.key === "Enter" || e.key === "Space") routeFunction({
                                                    route: "margin",
                                                    router: router,
                                                    i18n: i18n,
                                                    user: user,
                                                    phrase: phrase,
                                                    referral: referral
                                                });
                                            },
                                            tabIndex: 0,
                                            children: t("nav.trade.dropDown.main3")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (MainHeader_module_default()).subroute,
                                            role: "button",
                                            onClick: function() {
                                                return routeFunction({
                                                    route: "bitcast",
                                                    router: router,
                                                    i18n: i18n,
                                                    user: user,
                                                    phrase: phrase,
                                                    referral: referral
                                                });
                                            },
                                            onKeyUp: function(e) {
                                                if (e.key === "Enter" || e.key === "Space") routeFunction({
                                                    route: "bitcast",
                                                    router: router,
                                                    i18n: i18n,
                                                    user: user,
                                                    phrase: phrase,
                                                    referral: referral
                                                });
                                            },
                                            tabIndex: 0,
                                            children: t("nav.trade.dropDown.main4")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (MainHeader_module_default()).subroute,
                                            role: "button",
                                            onClick: function() {
                                                return routeFunction({
                                                    route: "copyTrade",
                                                    router: router,
                                                    i18n: i18n,
                                                    user: user,
                                                    phrase: phrase,
                                                    referral: referral
                                                });
                                            },
                                            onKeyUp: function(e) {
                                                if (e.key === "Enter" || e.key === "Space") routeFunction({
                                                    route: "copyTrade",
                                                    router: router,
                                                    i18n: i18n,
                                                    user: user,
                                                    phrase: phrase,
                                                    referral: referral
                                                });
                                            },
                                            tabIndex: 0,
                                            children: t("nav.copyTrading.title")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("details", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("summary", {
                                            className: (MainHeader_module_default()).route,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyCrypto, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: t("nav.buyCrypto.title")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (MainHeader_module_default()).subroute,
                                            role: "button",
                                            onClick: function() {
                                                return routeFunction({
                                                    route: "c2c",
                                                    router: router,
                                                    i18n: i18n,
                                                    user: user,
                                                    phrase: phrase,
                                                    referral: referral
                                                });
                                            },
                                            onKeyUp: function(e) {
                                                if (e.key === "Enter" || e.key === "Space") routeFunction({
                                                    route: "c2c",
                                                    router: router,
                                                    i18n: i18n,
                                                    user: user,
                                                    phrase: phrase,
                                                    referral: referral
                                                });
                                            },
                                            tabIndex: 0,
                                            children: t("nav.buyCrypto.dropDown.main1")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("details", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("summary", {
                                            className: (MainHeader_module_default()).route,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Support, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: t("nav.support.title")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (MainHeader_module_default()).subroute,
                                            role: "button",
                                            onClick: function() {
                                                return routeFunction({
                                                    route: "announcement",
                                                    router: router,
                                                    i18n: i18n,
                                                    user: user,
                                                    phrase: phrase,
                                                    referral: referral
                                                });
                                            },
                                            onKeyUp: function(e) {
                                                if (e.key === "Enter" || e.key === "Space") routeFunction({
                                                    route: "announcement",
                                                    router: router,
                                                    i18n: i18n,
                                                    user: user,
                                                    phrase: phrase,
                                                    referral: referral
                                                });
                                            },
                                            tabIndex: 0,
                                            children: t("nav.support.dropDown.main1")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (MainHeader_module_default()).subroute,
                                            role: "button",
                                            onClick: function() {
                                                return routeFunction({
                                                    route: "helpCenter",
                                                    router: router,
                                                    i18n: i18n,
                                                    user: user,
                                                    phrase: phrase,
                                                    referral: referral
                                                });
                                            },
                                            onKeyUp: function(e) {
                                                if (e.key === "Enter" || e.key === "Space") routeFunction({
                                                    route: "helpCenter",
                                                    router: router,
                                                    i18n: i18n,
                                                    user: user,
                                                    phrase: phrase,
                                                    referral: referral
                                                });
                                            },
                                            tabIndex: 0,
                                            children: t("nav.support.dropDown.main2")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (MainHeader_module_default()).subroute,
                                            role: "button",
                                            onClick: function() {
                                                return routeFunction({
                                                    route: "legalCenter",
                                                    router: router,
                                                    i18n: i18n,
                                                    user: user,
                                                    phrase: phrase,
                                                    referral: referral
                                                });
                                            },
                                            onKeyUp: function(e) {
                                                if (e.key === "Enter" || e.key === "Space") routeFunction({
                                                    route: "legalCenter",
                                                    router: router,
                                                    i18n: i18n,
                                                    user: user,
                                                    phrase: phrase,
                                                    referral: referral
                                                });
                                            },
                                            tabIndex: 0,
                                            children: t("nav.support.dropDown.main3")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("details", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("summary", {
                                            className: (MainHeader_module_default()).route,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(More, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: t("nav.more.title")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (MainHeader_module_default()).subroute,
                                            role: "button",
                                            onClick: function() {
                                                return routeFunction({
                                                    route: "agent",
                                                    router: router,
                                                    i18n: i18n,
                                                    user: user,
                                                    phrase: phrase,
                                                    referral: referral
                                                });
                                            },
                                            onKeyUp: function(e) {
                                                if (e.key === "Enter" || e.key === "Space") routeFunction({
                                                    route: "agent",
                                                    router: router,
                                                    i18n: i18n,
                                                    user: user,
                                                    phrase: phrase,
                                                    referral: referral
                                                });
                                            },
                                            tabIndex: 0,
                                            children: t("nav.more.dropDown.main1")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (MainHeader_module_default()).subroute,
                                            role: "button",
                                            onClick: function() {
                                                return routeFunction({
                                                    route: "exchange",
                                                    router: router,
                                                    i18n: i18n,
                                                    user: user,
                                                    phrase: phrase,
                                                    referral: referral
                                                });
                                            },
                                            onKeyUp: function(e) {
                                                if (e.key === "Enter" || e.key === "Space") routeFunction({
                                                    route: "exchange",
                                                    router: router,
                                                    i18n: i18n,
                                                    user: user,
                                                    phrase: phrase,
                                                    referral: referral
                                                });
                                            },
                                            tabIndex: 0,
                                            children: t("nav.more.dropDown.main2")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (MainHeader_module_default()).subroute,
                                            role: "button",
                                            onClick: function() {
                                                return routeFunction({
                                                    route: "eventCenter",
                                                    router: router,
                                                    i18n: i18n,
                                                    user: user,
                                                    phrase: phrase,
                                                    referral: referral
                                                });
                                            },
                                            onKeyUp: function(e) {
                                                if (e.key === "Enter" || e.key === "Space") routeFunction({
                                                    route: "eventCenter",
                                                    router: router,
                                                    i18n: i18n,
                                                    user: user,
                                                    phrase: phrase,
                                                    referral: referral
                                                });
                                            },
                                            tabIndex: 0,
                                            children: t("nav.more.dropDown.main4")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (MainHeader_module_default()).route,
                                    role: "button",
                                    onClick: function() {
                                        return routeFunction({
                                            route: "quizPool",
                                            router: router,
                                            t: t,
                                            i18n: i18n,
                                            user: user,
                                            phrase: phrase,
                                            referral: referral
                                        });
                                    },
                                    onKeyUp: function(e) {
                                        if (e.key === "Enter" || e.key === "Space") routeFunction({
                                            route: "quizPool",
                                            router: router,
                                            t: t,
                                            i18n: i18n,
                                            user: user,
                                            phrase: phrase,
                                            referral: referral
                                        });
                                    },
                                    tabIndex: 0,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(QuizPool, {}),
                                        t("nav.quizPool.title"),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (MainHeader_module_default()).tips,
                                            children: t("nav.quizPool.tips")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (MainHeader_module_default()).route,
                                    role: "button",
                                    onClick: function() {
                                        return routeFunction({
                                            route: "download",
                                            router: router,
                                            i18n: i18n,
                                            user: user,
                                            phrase: phrase,
                                            referral: referral
                                        });
                                    },
                                    onKeyUp: function(e) {
                                        if (e.key === "Enter" || e.key === "Space") routeFunction({
                                            route: "download",
                                            router: router,
                                            i18n: i18n,
                                            user: user,
                                            phrase: phrase,
                                            referral: referral
                                        });
                                    },
                                    tabIndex: 0,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_DownLoadIcon, {}),
                                        t("download.title")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("details", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("summary", {
                                            className: (MainHeader_module_default()).route,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_LanguageIcon, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: t("language.title")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (MainHeader_module_default()).subroute,
                                            role: "button",
                                            onClick: function() {
                                                handleLocaleChange("zh");
                                                setHamburg(false);
                                            },
                                            onKeyUp: function(e) {
                                                if (e.key === "Enter" || e.key === "Space") {
                                                    handleLocaleChange("zh");
                                                    setHamburg(false);
                                                }
                                            },
                                            tabIndex: 0,
                                            children: "简体中文"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (MainHeader_module_default()).subroute,
                                            role: "button",
                                            onClick: function() {
                                                handleLocaleChange("en");
                                                setHamburg(false);
                                            },
                                            onKeyUp: function(e) {
                                                if (e.key === "Enter" || e.key === "Space") {
                                                    handleLocaleChange("en");
                                                    setHamburg(false);
                                                }
                                            },
                                            tabIndex: 0,
                                            children: "English"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (MainHeader_module_default()).route,
                                    role: "button",
                                    onClick: function() {
                                        return routeFunction({
                                            route: "",
                                            router: router,
                                            i18n: i18n,
                                            user: user,
                                            phrase: phrase,
                                            referral: referral
                                        });
                                    },
                                    onKeyUp: function(e) {
                                        if (e.key === "Enter" || e.key === "Space") routeFunction({
                                            route: "",
                                            router: router,
                                            i18n: i18n,
                                            user: user,
                                            phrase: phrase,
                                            referral: referral
                                        });
                                    },
                                    tabIndex: 0,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(oldVersion, {}),
                                        t("loginPopup.oldVersionBtn")
                                    ]
                                }),
                                user && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (MainHeader_module_default()).route,
                                    role: "button",
                                    onClick: function() {
                                        return logout();
                                    },
                                    onKeyUp: function(e) {
                                        if (e.key === "Enter" || e.key === "Space") logout();
                                    },
                                    tabIndex: 0,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Logout, {}),
                                        t("user.logout")
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
function MainHeader() {
    var Desktop = function Desktop() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (MainHeader_module_default()).desktop,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (MainHeader_module_default()).nav,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "".concat(langUrl, "/"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg_Logo, {})
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                            className: (MainHeader_module_default()).navLinks,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (MainHeader_module_default()).btnCon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "".concat(langUrl, "/markets"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                            variant: "empty",
                                            className: (MainHeader_module_default()).navDropDown,
                                            children: t("nav.markets.title")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (MainHeader_module_default()).btnCon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdwon/* Tooltip */.u, {
                                        className: (MainHeader_module_default()).dropDownSelector,
                                        anchor: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                            variant: "empty",
                                            children: t("nav.trade.title")
                                        }),
                                        children: user === undefined ? getEmptyHeader(3) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                                                    onClick: function() {
                                                        window.location.href = user ? "/trade/spot/BTCUSDT_CC" : "".concat(langUrl, "/trade/spotV2/BTCUSDT_CC");
                                                    },
                                                    variant: "plane",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: t("nav.trade.dropDown.main1")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: t("nav.trade.dropDown.desc1")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                                                    onClick: function() {
                                                        window.location.href = user ? "/trade/deal/BTCUSDT" : "".concat(langUrl, "/trade/margin/BTCUSDT");
                                                    },
                                                    variant: "plane",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: t("nav.trade.dropDown.main3")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: t("nav.trade.dropDown.desc3")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                                                    onClick: function() {
                                                        window.location.href = user ? "/trade/game/BTCUSDT" : "".concat(langUrl, "/trade/bitcast/BTCUSDT");
                                                    },
                                                    variant: "plane",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: t("nav.trade.dropDown.main4")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: t("nav.trade.dropDown.desc4")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                                                    "data-path": "/trade/follow",
                                                    onClick: handleRedirectTo,
                                                    variant: "plane",
                                                    className: (MainHeader_module_default()).navDropDown,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: t("nav.copyTrading.title")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: t("nav.copyTrading.desc")
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (MainHeader_module_default()).btnCon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdwon/* Tooltip */.u, {
                                        className: (MainHeader_module_default()).dropDownSelector,
                                        anchor: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                            variant: "empty",
                                            children: t("nav.buyCrypto.title")
                                        }),
                                        children: user === undefined ? getEmptyHeader(1) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                                            onClick: function() {
                                                window.location.href = user ? "/c2c" : "/download";
                                            },
                                            variant: "plane",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: t("nav.buyCrypto.dropDown.main1")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: t("nav.buyCrypto.dropDown.desc1")
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (MainHeader_module_default()).btnCon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdwon/* Tooltip */.u, {
                                        className: (MainHeader_module_default()).dropDownSelector,
                                        anchor: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                            variant: "empty",
                                            children: t("nav.support.title")
                                        }),
                                        children: user === undefined ? getEmptyHeader(3) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                                                    onClick: function() {
                                                        return router.push("".concat(langUrl, "/news/announcement"));
                                                    },
                                                    variant: "plane",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: t("nav.support.dropDown.main1")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: t("nav.support.dropDown.desc1")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                                                    onClick: function() {
                                                        return router.push("".concat(langUrl, "/helpCenter/beginnerGuide"));
                                                    },
                                                    variant: "plane",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: t("nav.support.dropDown.main2")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: t("nav.support.dropDown.desc2")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                                                    onClick: function() {
                                                        return router.push("".concat(langUrl, "/legalCenter/termsOfService"));
                                                    },
                                                    variant: "plane",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: t("nav.support.dropDown.main3")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: t("nav.support.dropDown.desc3")
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (MainHeader_module_default()).btnCon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdwon/* Tooltip */.u, {
                                        className: (MainHeader_module_default()).dropDownSelector,
                                        anchor: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                            variant: "empty",
                                            children: t("nav.more.title")
                                        }),
                                        children: user === undefined ? getEmptyHeader(3) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                                                    "data-path": user ? "/trade/agent/agent" : "toLogin",
                                                    onClick: handleRedirectTo,
                                                    variant: "plane",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: t("nav.more.dropDown.main1")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: t("nav.more.dropDown.desc1")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                                                    "data-path": "/trade/fastChange",
                                                    onClick: handleRedirectTo,
                                                    variant: "plane",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: t("nav.more.dropDown.main2")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: t("nav.more.dropDown.desc2")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                                                    onClick: function() {
                                                        return router.push("".concat(langUrl, "/news/stories"));
                                                    },
                                                    variant: "plane",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: t("nav.more.dropDown.main3")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: t("nav.more.dropDown.desc3")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                                                    onClick: function() {
                                                        return router.push("/eventCenter");
                                                    },
                                                    variant: "plane",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: t("nav.more.dropDown.main4")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: t("nav.more.dropDown.desc4")
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (MainHeader_module_default()).btnCon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                        variant: "empty",
                                        className: (MainHeader_module_default()).navDropDown,
                                        onClick: function() {
                                            return quizPoolSetTime(langUrl);
                                        },
                                        children: t("nav.quizPool.title")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdwon/* Tooltip */.u, {
                                    className: (MainHeader_module_default()).quizPool,
                                    show: "center",
                                    special: "newQuizPool",
                                    anchor: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (MainHeader_module_default()).tips,
                                        children: t("nav.quizPool.tips")
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (MainHeader_module_default()).todayCP,
                                        children: [
                                            t("nav.quizPool.dropDown.main"),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: poolInfo ? poolInfo.poolPrize || 0 : 0
                                                    }),
                                                    " ",
                                                    "USDT"
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: (MainHeader_module_default()).functionality,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (MainHeader_module_default()).user,
                            children: authSection
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (MainHeader_module_default()).btnCon,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdwon/* Tooltip */.u, {
                                className: (MainHeader_module_default()).downLoadInfo,
                                show: "right",
                                anchor: /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_DownLoadIcon, {})
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (MainHeader_module_default()).downLoadDropDown,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (MainHeader_module_default()).qrcode,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: qrCode,
                                                    layout: "fill"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (MainHeader_module_default()).downLoadRight,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (MainHeader_module_default()).firstRow,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_PhoneIcon, {}),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: t("download.device")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (MainHeader_module_default()).secondRow,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        dangerouslySetInnerHTML: {
                                                            __html: t("download.details")
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (MainHeader_module_default()).thirdRow,
                                                    role: "button",
                                                    onClick: function() {
                                                        return router.push("/download");
                                                    },
                                                    onKeyUp: function(e) {
                                                        if (e.key === "Enter" || e.key === "Space") router.push("/download");
                                                    },
                                                    tabIndex: 0,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: t("download.btn")
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (MainHeader_module_default()).btnCon,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdwon/* Tooltip */.u, {
                                className: (MainHeader_module_default()).languageSelector,
                                show: "center",
                                anchor: /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_LanguageIcon, {})
                                }),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                        variant: "plane",
                                        selected: i18n.language === "zh",
                                        onClick: function() {
                                            return handleLocaleChange("zh");
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "简体中文"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                        variant: "plane",
                                        selected: i18n.language === "en",
                                        onClick: function() {
                                            return handleLocaleChange("en");
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "English"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        });
    };
    var router = (0,next_router.useRouter)();
    var _auth = (0,store/* useStore */.oR)().auth, user = _auth.user, kyc = _auth.kyc, logout = _auth.logout;
    var _setting = (0,store/* useStore */.oR)().setting, storageData = _setting.storageData, setLanguage = _setting.setLanguage;
    var ref = (0,esm/* useTranslation */.$G)("common", {
        keyPrefix: "newHeader"
    }), t = ref.t, i18n = ref.i18n;
    var qrCode = (0,useQRcode/* default */.Z)({
        locale: i18n.language,
        ru: storageData === null || storageData === void 0 ? void 0 : storageData.ru
    }).qrCode;
    var ref1 = (0,Modal_Portal/* default */.Z)({
        closeOnOutSide: true
    }), Portal = ref1.Portal, PortalOpen = ref1.PortalOpen, PortalClose = ref1.PortalClose;
    // pool info
    var poolInfo = (0,usePoolListData/* usePoolInfo */.aD)().poolInfo;
    var handleRedirectTo = (0,react.useCallback)(function(e) {
        var dataset = e.currentTarget.dataset;
        if (dataset.path === "toLogin") return PortalOpen();
        return (0,sessionPass/* default */.ZP)(dataset.path);
    }, []);
    var handleLocaleChange = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(locale) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            setLanguage(locale)
                        ];
                    case 1:
                        _state.sent();
                        router.replace(router.asPath, router.asPath, {
                            locale: locale
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function(locale) {
            return _ref.apply(this, arguments);
        };
    }(), [
        router
    ]);
    var kycLvl = (kyc === null || kyc === void 0 ? void 0 : kyc.currentLevel) || 0;
    var renderUserMenu = (0,react.useMemo)(function() {
        if (!user) return undefined;
        var account = user.account, userId = user.userId;
        var kycTxt = [
            t("user.kycLevel.0"),
            t("user.kycLevel.0"),
            t("user.kycLevel.0"),
            t("user.kycLevel.1")
        ][kycLvl];
        var kycTagLvl = [
            (MainHeader_module_default()).unAuth,
            (MainHeader_module_default()).unAuth,
            (MainHeader_module_default()).unAuth,
            (MainHeader_module_default()).advanceAuth
        ][kycLvl];
        var KycIcon = [
            icons_UnAuthIcon,
            icons_UnAuthIcon,
            icons_UnAuthIcon,
            icons_AdvanceAuthIcon
        ][kycLvl];
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: (MainHeader_module_default()).profile,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                    className: (MainHeader_module_default()).account,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: userNameCover(account)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (MainHeader_module_default()).id,
                                    children: "ID : ".concat(userId)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()((MainHeader_module_default()).kycTag, kycTagLvl),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(KycIcon, {}),
                                kycTxt
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                    className: (MainHeader_module_default()).profileNav,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            "data-path": "/trade/account/account",
                            onClick: handleRedirectTo,
                            variant: "plane",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: t("user.overview")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            "data-path": "/trade/account/secure",
                            onClick: handleRedirectTo,
                            variant: "plane",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: t("user.security")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            "data-path": "/trade/account/followManagement",
                            onClick: handleRedirectTo,
                            variant: "plane",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: t("user.follow")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            "data-path": "/trade/account/bringManagement",
                            onClick: handleRedirectTo,
                            variant: "plane",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: t("user.lead")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            onClick: logout,
                            variant: "plane",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: t("user.logout")
                            })
                        })
                    ]
                })
            ]
        });
    }, [
        t,
        user,
        kycLvl,
        logout,
        handleRedirectTo
    ]);
    var authSection = (0,react.useMemo)(function() {
        if (user === undefined) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (MainHeader_module_default()).loading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {})
            });
        }
        if (user === false) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        "data-path": "/login",
                        onClick: handleRedirectTo,
                        className: (MainHeader_module_default()).login,
                        variant: "plane",
                        children: t("login")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        "data-path": "/register",
                        onClick: handleRedirectTo,
                        className: (MainHeader_module_default()).register,
                        variant: "plane",
                        children: t("getStarted")
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (MainHeader_module_default()).btnCon,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdwon/* Tooltip */.u, {
                        className: (MainHeader_module_default()).assetSelector,
                        show: "center",
                        anchor: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            variant: "empty",
                            children: t("asset.title")
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                "data-path": "/trade/asset/asset",
                                variant: "plane",
                                onClick: handleRedirectTo,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: t("asset.assetDetail")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                "data-path": "/trade/asset/Recharge",
                                variant: "plane",
                                onClick: handleRedirectTo,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: t("asset.balanceDetail")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                "data-path": "/trade/asset/Spotg",
                                variant: "plane",
                                onClick: handleRedirectTo,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: t("asset.orderDetail")
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (MainHeader_module_default()).btnCon,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdwon/* Tooltip */.u, {
                        className: (MainHeader_module_default()).historySelector,
                        show: "center",
                        anchor: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                            variant: "empty",
                            children: [
                                t("order.title"),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (MainHeader_module_default()).triangle
                                })
                            ]
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                "data-path": "/trade/asset/Agreement",
                                variant: "plane",
                                onClick: handleRedirectTo,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: t("order.contract")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                "data-path": "/trade/asset/Spotg",
                                variant: "plane",
                                onClick: handleRedirectTo,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: t("order.spot")
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (MainHeader_module_default()).btnCon,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdwon/* Tooltip */.u, {
                        className: (MainHeader_module_default()).profileSelector,
                        show: "center",
                        anchor: /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_ProfileIcon, {})
                        }),
                        children: renderUserMenu
                    })
                })
            ]
        });
    }, [
        t,
        user,
        handleRedirectTo,
        renderUserMenu
    ]);
    var getEmptyHeader = function(num) {
        var emptyLoadingArray = [];
        for(var i = 0; i < num; i++){
            emptyLoadingArray.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {})
            }, i));
        }
        return emptyLoadingArray;
    };
    var langUrl = "";
    if (i18n.language === "en") {
        langUrl = "/en";
    }
    var quizPoolSetTime = function(lang) {
        var now = new Date(); // date now
        var start = 1713801600000; // 2024-04-23 00:00:00
        var distance = start - now.getTime();
        var tempHours = Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
        var tempMinutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
        var tempSeconds = Math.floor(distance % (1000 * 60) / 1000);
        var countDownErr = t("nav.quizPool.countDownErr", {
            h: tempHours,
            m: tempMinutes,
            s: tempSeconds
        });
        if (start < now) {
            router.push("".concat(lang, "/quizPool"));
        } else {
            dist/* toast.error */.Am.error(countDownErr, {
                id: "countDownErr"
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (MainHeader_module_default()).container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Mobile, {
                        t: t,
                        router: router,
                        setLanguage: setLanguage,
                        i18n: i18n,
                        user: user,
                        logout: logout
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (MainHeader_module_default()).portal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Portal, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ServicePlatformChoice/* default */.Z, {
                        cross: true,
                        closeFunc: PortalClose,
                        width: "10%"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var header_MainHeader = ((0,mobxreact_esm/* observer */.Pi)(MainHeader));

;// CONCATENATED MODULE: ./src/layout/header/index.js
/* eslint-disable import/prefer-default-export */ 

;// CONCATENATED MODULE: ./src/layout/footer/icons/TgIcon.js

function TgIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "21",
        height: "21",
        viewBox: "0 0 32 32",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                id: "Icons-/-Systems-/-Media-/-Telegram-Hover",
                stroke: "none",
                strokeWidth: "1",
                fillRule: "evenodd",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "currentColor",
                    d: "M16,0.001 C24.836556,0.001 32,7.164444 32,16.001 C32,24.837556 24.836556,32.001 16,32.001 C7.163444,32.001 0,24.837556 0,16.001 C0,7.164444 7.163444,0.001 16,0.001 Z M23.8573333,10.9636667 C24.0893333,9.881 23.464,9.44766667 22.748,9.70633333 L22.748,9.70633333 L7.32133333,15.6543333 C6.264,16.0676667 6.28266667,16.653 7.14,16.925 L7.14,16.925 L11.0893333,18.157 L20.2506667,12.389 C20.676,12.1063333 21.0706667,12.2663333 20.748,12.5503333 L20.748,12.5503333 L13.3346667,19.2476667 L13.0506667,23.3183333 C13.464,23.3183333 13.644,23.1383333 13.8573333,22.925 L13.8573333,22.925 L15.7866667,21.0663333 L19.7866667,24.0143333 C20.516,24.4276667 21.0373333,24.2143333 21.232,23.337 L21.232,23.337 L23.8586667,10.9623333 Z",
                    id: "Combined-Shape",
                    fillRule: "nonzero"
                })
            })
        ]
    });
}
/* harmony default export */ var icons_TgIcon = (TgIcon);

;// CONCATENATED MODULE: ./src/layout/footer/icons/LiIcon.js

function LiIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "21",
        height: "21",
        viewBox: "0 0 32 32",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                id: "Icons-/-Systems-/-Media-/-Linkedin-Hover",
                stroke: "none",
                strokeWidth: "1",
                fillRule: "evenodd",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "currentColor",
                    d: "M16,0 C24.836556,0 32,7.163444 32,16 C32,24.836556 24.836556,32 16,32 C7.163444,32 0,24.836556 0,16 C0,7.163444 7.163444,0 16,0 Z M11.7708296,12.3811901 L7.94752041,12.3811901 L7.94752041,23.8839174 L11.7708296,23.8839174 L11.7708296,12.3811901 Z M21.1572605,12.1110913 C19.1251025,12.1110913 18.2186887,13.2291347 17.7104353,14.0111947 L17.7104353,14.0111947 L17.7104353,12.3811901 L13.8854148,12.3811901 C13.9006263,12.7008846 13.9068236,13.8409471 13.9080129,15.2871671 L13.9080286,16.4212021 C13.9079621,16.5191497 13.9078799,16.617791 13.9077831,16.7170005 L13.9070338,17.3180722 C13.9027889,20.1455206 13.8885751,23.2216148 13.8858638,23.7905081 L13.8854148,23.8836322 L17.7101501,23.8836322 L17.7101501,17.459446 C17.7101501,17.1146208 17.7361047,16.7732183 17.8367856,16.5273628 C18.1140148,15.8394239 18.7417733,15.1289529 19.7984955,15.1289529 C21.1832151,15.1289529 21.7353916,16.184249 21.7353916,17.7295447 L21.7353916,17.7295447 L21.7353916,23.8839174 L25.5598417,23.8839174 L25.5598417,17.2874612 C25.5598417,13.7550715 23.6734286,12.1110913 21.1572605,12.1110913 Z M9.88441656,6.83660737 C8.57613462,6.83660737 7.72020393,7.69539021 7.72020393,8.82370138 C7.72020393,9.92805448 8.5513209,10.811651 9.83421869,10.811651 L9.85903241,10.811651 C11.1929837,10.811651 12.0223894,9.92805448 12.0223894,8.82370138 C11.9970052,7.69539021 11.1929837,6.83660737 9.88441656,6.83660737 Z",
                    id: "Combined-Shape",
                    fillRule: "nonzero"
                })
            })
        ]
    });
}
/* harmony default export */ var icons_LiIcon = (LiIcon);

;// CONCATENATED MODULE: ./src/layout/footer/icons/IgIcon.js

function IgIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "21",
        height: "21",
        viewBox: "0 0 32 32",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                id: "Icons-/-Systems-/-Media-/-Instagram-Hover",
                stroke: "none",
                strokeWidth: "1",
                fillRule: "evenodd",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "currentColor",
                    d: "M16,0 C24.8352051,0 32,7.16479494 32,16 C32,24.8352051 24.8352051,32 16,32 C7.16479494,32 0,24.8352051 0,16 C0,7.16479494 7.16479494,0 16,0 Z M16.7809148,6.81296506 L15.2190852,6.81296468 C13.4237779,6.81543077 13.078848,6.82839731 12.2121582,6.86791994 C11.2341309,6.91259763 10.5664062,7.06787113 9.98193363,7.29492188 C9.3688965,7.52563475 8.81347656,7.887207 8.35473631,8.35473631 C7.887207,8.81347656 7.52539063,9.3688965 7.29467775,9.98193363 C7.06762694,10.5664063 6.9123535,11.2341309 6.86791994,12.2121582 C6.82818136,13.078848 6.81538094,13.4237779 6.81295606,15.2190852 L6.81295643,16.7809152 C6.81443419,17.8737127 6.81976437,18.4291384 6.83272041,18.8920029 L6.83875089,19.0860032 C6.84635682,19.3087512 6.85600399,19.5242451 6.86816406,19.7880859 C6.91259763,20.7658691 7.06811525,21.4338379 7.295166,22.0180664 C7.52587888,22.6311035 7.88745119,23.1865234 8.35473631,23.6452637 C8.81372069,24.112793 9.3688965,24.4743653 9.98217775,24.7050781 C10.5664062,24.9321289 11.234375,25.0874024 12.2121582,25.1320801 C13.079064,25.1716027 13.4238278,25.1845692 15.2192628,25.1870353 L16.7811589,25.1870353 C18.5764662,25.1845692 18.9213961,25.1716027 19.7880859,25.1320801 C20.7658691,25.0874024 21.4338379,24.9321289 22.0180664,24.7050781 C23.2521973,24.2277832 24.2277832,23.2521973 24.7050781,22.0180664 C24.9321289,21.4335938 25.0876465,20.7658691 25.1320801,19.7878418 C25.1718186,18.921152 25.1846191,18.5762221 25.1870439,16.7809148 L25.1870443,15.2190852 C25.1854648,14.0482326 25.1794815,13.4942702 25.1645472,13.0101475 L25.1580853,12.8189265 C25.1511245,12.6288369 25.1426345,12.4382512 25.1323242,12.2121582 C25.0876465,11.2341309 24.9323731,10.5664063 24.7050781,9.98193363 C24.4746094,9.3688965 24.112793,8.81372069 23.6455078,8.35473631 C23.1865234,7.887207 22.6311035,7.52539063 22.0180664,7.29467775 C21.4335938,7.06787113 20.7658691,6.91259763 19.7878418,6.86816406 C18.921152,6.82842548 18.5762221,6.81543402 16.7809148,6.81296506 Z M16.9889996,8.46878521 C18.0591656,8.47081879 18.5550122,8.47730917 19.0220897,8.49308503 L19.2086795,8.49990205 C19.3650477,8.50601466 19.5263015,8.51323053 19.7126465,8.5217285 C20.6083984,8.5625 21.0947266,8.71215819 21.418457,8.83789062 C21.8176269,8.98510744 22.1784668,9.21997069 22.4748535,9.5251465 C22.7800293,9.82153319 23.0148926,10.1826172 23.1621094,10.581543 C23.2880859,10.9052734 23.4377441,11.3918457 23.4785156,12.2875976 C23.5159067,13.1073092 23.5283015,13.4414294 23.5312303,15.0111492 L23.5312303,16.9892437 C23.5283015,18.5588205 23.5159067,18.8929725 23.4785156,19.7128906 C23.4375,20.6086426 23.2878418,21.0949707 23.1621094,21.4187012 C22.8530274,22.2199707 22.2197266,22.8532715 21.418457,23.1623535 C21.0947266,23.2883301 20.6081543,23.4379882 19.7124024,23.4787597 C18.9301476,23.5144513 18.5901836,23.5273672 17.1955202,23.531015 L16.7670525,23.5318166 C16.6904269,23.5319121 16.6110865,23.5319895 16.5288695,23.5320502 L15.4706984,23.5320502 C15.3884906,23.5319895 15.3091594,23.5319121 15.232543,23.5318166 L14.8041289,23.531015 C13.4096481,23.5273672 13.0698054,23.5144513 12.2873535,23.4787597 C11.3916016,23.4379882 10.9050293,23.2883301 10.5812988,23.1623535 C10.1821289,23.0151367 9.82128906,22.7802734 9.52490238,22.4750976 C9.21972656,22.1787109 8.98510744,21.8178711 8.8376465,21.4187012 C8.71191406,21.0949707 8.56225588,20.6086426 8.52148438,19.7128906 C8.48069413,18.8184345 8.46944342,18.5020802 8.4679539,16.5292537 L8.4679539,15.4711825 C8.46944342,13.4981653 8.48069413,13.1818284 8.52148438,12.2875976 C8.56225588,11.3918457 8.71191406,10.9052734 8.8376465,10.581543 C8.98510744,10.1823731 9.21997069,9.82153319 9.5251465,9.5251465 C9.82128906,9.21997069 10.1823731,8.98510744 10.581543,8.83789062 C10.9050293,8.71215819 11.3916016,8.5625 12.2873535,8.52148437 C13.107065,8.48409331 13.4411852,8.47169846 15.0109051,8.46876966 Z M16,11.2822266 C13.3942871,11.2822266 11.2819824,13.3942871 11.2819824,16 C11.2819824,18.6057129 13.3942871,20.7177734 16,20.7177734 C18.6054688,20.7177734 20.7177734,18.6057129 20.7177734,16 C20.7177734,13.3942871 18.6054688,11.2822266 16,11.2822266 Z M16,12.9375 C17.6914062,12.9375 19.0625,14.3085938 19.0625,16 C19.0625,17.6914062 17.6914062,19.0625 16,19.0625 C14.3085938,19.0625 12.9375,17.6914062 12.9375,16 C12.9375,14.3085938 14.3085938,12.9375 16,12.9375 Z M20.9042969,9.99316406 C20.2954101,9.99316406 19.8017578,10.4868164 19.8017578,11.0957031 C19.8017578,11.7045899 20.2954101,12.1982422 20.9042969,12.1982422 C21.5131836,12.1982422 22.0065918,11.7045899 22.0068359,11.0957031 C22.0068359,10.4868164 21.5131836,9.99316406 20.9042969,9.99316406 Z",
                    id: "Combined-Shape",
                    fillRule: "nonzero"
                })
            })
        ]
    });
}
/* harmony default export */ var icons_IgIcon = (IgIcon);

;// CONCATENATED MODULE: ./src/layout/footer/icons/MdIcon.js

function MdIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "21",
        height: "21",
        viewBox: "0 0 21 21",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                id: "Icons-/-Systems-/-Media-/-Medium-Hover",
                stroke: "none",
                strokeWidth: "1",
                fillRule: "evenodd",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "currentColor",
                    d: "M9.618 0.57a87.731 87.731 0 0 0 -0.615 0.082c-1.784 0.238 -3.515 0.988 -5.045 2.182 -0.451 0.353 -1.444 1.378 -1.813 1.874C1.079 6.136 0.41 7.735 0.139 9.507c-0.107 0.697 -0.107 2.297 0 2.994 0.345 2.239 1.3 4.175 2.855 5.779 1.612 1.665 3.683 2.732 5.988 3.08 0.664 0.102 1.956 0.127 2.637 0.045 2.371 -0.275 4.422 -1.23 6.091 -2.834 1.731 -1.661 2.785 -3.696 3.154 -6.091 0.102 -0.673 0.102 -2.285 -0.004 -2.974 -0.271 -1.776 -0.952 -3.396 -2.043 -4.848 -0.34 -0.455 -1.345 -1.485 -1.776 -1.825 -1.513 -1.185 -3.158 -1.903 -5.024 -2.19 -0.41 -0.062 -2.104 -0.115 -2.399 -0.074zm-1.842 5.865c0.439 0.078 0.833 0.213 1.276 0.443 1.395 0.726 2.309 2.096 2.473 3.704 0.053 0.521 0 1.099 -0.144 1.653 -0.459 1.706 -1.878 3.015 -3.626 3.347 -0.463 0.09 -1.272 0.086 -1.706 -0.004 -0.931 -0.197 -1.731 -0.619 -2.379 -1.272 -2.133 -2.133 -1.714 -5.693 0.861 -7.284 0.952 -0.587 2.084 -0.792 3.244 -0.587zm7.133 0.34c0.787 0.39 1.44 1.641 1.645 3.162 0.074 0.554 0.074 1.579 0 2.133 -0.205 1.53 -0.853 2.773 -1.657 3.166 -0.234 0.115 -0.316 0.135 -0.583 0.135s-0.349 -0.021 -0.582 -0.135c-0.747 -0.369 -1.353 -1.448 -1.62 -2.879 -0.102 -0.554 -0.102 -2.153 0 -2.707 0.119 -0.644 0.266 -1.099 0.517 -1.62 0.587 -1.202 1.436 -1.669 2.28 -1.255zm3.15 0.406c0.234 0.242 0.418 0.906 0.55 1.977 0.102 0.837 0.102 2.855 0 3.691 -0.135 1.095 -0.324 1.76 -0.566 1.993 -0.115 0.111 -0.127 0.115 -0.234 0.057 -0.287 -0.164 -0.509 -0.906 -0.648 -2.186 -0.082 -0.755 -0.094 -2.518 -0.021 -3.269 0.123 -1.251 0.361 -2.129 0.627 -2.313 0.127 -0.09 0.164 -0.082 0.291 0.049z",
                    id: "Path",
                    fillRule: "nonzero"
                })
            })
        ]
    });
}
/* harmony default export */ var icons_MdIcon = (MdIcon);

;// CONCATENATED MODULE: ./src/layout/footer/icons/LtIcon.js

function LtIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "21",
        height: "21",
        viewBox: "0 0 32 32",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                id: "Icons-/-Systems-/-Media-/-Linktree-Hover",
                stroke: "none",
                strokeWidth: "1",
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "currentColor",
                        d: "M16 0C7.165 0 0 7.162 0 16c0 8.835 7.165 16 16 16s16 -7.165 16 -16S24.835 0 16 0z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M14.688 19.13h2.611V25.024H14.688V19.13zM8.653 13.088h4.442l-3.158 -3.011 1.747 -1.795 3.011 3.094V6.976h2.611v4.4l3.011 -3.088 1.747 1.789 -3.155 3.005h4.442v2.483H18.88l3.178 3.088 -1.741 1.754L16 16.07 11.686 20.406l-1.747 -1.747 3.178 -3.088H8.653V13.088z",
                        id: "Path",
                        fillRule: "nonzero"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var icons_LtIcon = (LtIcon);

;// CONCATENATED MODULE: ./src/layout/footer/icons/TwIcon.js

function TwICon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        version: "1.1",
        width: "22",
        height: "22",
        viewBox: "0 0 256 256",
        xmlSpace: "preserve",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            style: {
                stroke: "none",
                strokeWidth: 0,
                strokeDasharray: "none",
                strokeLinecap: "butt",
                strokeLinejoin: "miter",
                strokeMiterlimit: 10,
                fill: "none",
                fillRule: "nonzero",
                opacity: 1
            },
            transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                    points: "24.89,23.01 57.79,66.99 65.24,66.99 32.34,23.01",
                    style: {
                        stroke: "none",
                        strokeWidth: 1,
                        strokeDasharray: "none",
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 10,
                        fill: "rgb(0,0,0)",
                        fillRule: "nonzero",
                        opacity: 1
                    },
                    transform: "matrix(1 0 0 1 0 0)"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "currentColor",
                    d: "M 45 0 L 45 0 C 20.147 0 0 20.147 0 45 v 0 c 0 24.853 20.147 45 45 45 h 0 c 24.853 0 45 -20.147 45 -45 v 0 C 90 20.147 69.853 0 45 0 z M 56.032 70.504 L 41.054 50.477 L 22.516 70.504 h -4.765 L 38.925 47.63 L 17.884 19.496 h 16.217 L 47.895 37.94 l 17.072 -18.444 h 4.765 L 50.024 40.788 l 22.225 29.716 H 56.032 z",
                    style: {
                        stroke: "none",
                        strokeWidth: 1,
                        strokeDasharray: "none",
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 10,
                        opacity: 1
                    },
                    transform: "matrix(1 0 0 1 0 0)",
                    strokeLinecap: "round"
                })
            ]
        })
    });
}
/* harmony default export */ var TwIcon = (TwICon);

;// CONCATENATED MODULE: ./src/layout/footer/icons/FbIcon.js

function FbIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        version: "1.0",
        xmlns: "http://www.w3.org/2000/svg",
        width: "22",
        height: "22",
        viewBox: "0 0 2084.000000 2084.000000",
        preserveAspectRatio: "xMidYMid meet",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            transform: "translate(0.000000,2084.000000) scale(0.100000,-0.100000)",
            fill: "currentColor",
            stroke: "none",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9920 20820 c-1333 -71 -2554 -361 -3730 -885 -2855 -1272 -4991 -3759 -5815 -6770 -259 -946 -378 -1902 -362 -2910 8 -467 28 -753 83 -1185 161 -1266 567 -2515 1180 -3638 1018 -1860 2569 -3362 4459 -4317 621 -313 1278 -566 1930 -743 99 -27 192 -52 208 -56 l27 -6 0 3460 0 3460 -1072 2 -1073 3 0 1590 0 1590 1071 3 1072 2 5 928 c5 900 9 1030 43 1392 170 1832 900 3055 2205 3695 587 288 1283 457 2159 525 228 18 824 24 1060 11 571 -32 1204 -106 1630 -191 107 -22 209 -43 225 -48 l30 -8 3 -1449 2 -1448 -62 6 c-293 30 -1331 42 -1583 19 -656 -60 -1086 -223 -1390 -527 -229 -229 -378 -530 -459 -928 -64 -311 -76 -528 -76 -1329 l0 -648 1700 0 c935 0 1700 -4 1700 -8 0 -5 -130 -719 -290 -1587 -159 -868 -290 -1582 -290 -1587 0 -4 -634 -8 -1410 -8 l-1410 0 0 -3575 c0 -2853 3 -3575 13 -3575 33 0 447 64 616 95 1630 299 3167 988 4491 2014 558 432 1139 991 1596 1537 413 491 805 1062 1128 1639 197 352 470 936 617 1323 706 1848 872 3861 478 5815 -457 2266 -1694 4356 -3469 5858 -1445 1222 -3164 2020 -5015 2329 -313 52 -664 92 -1040 120 -183 14 -987 21 -1185 10z"
            })
        })
    });
}
/* harmony default export */ var icons_FbIcon = (FbIcon);

// EXTERNAL MODULE: ./src/layout/footer/MainFooter.module.scss
var MainFooter_module = __webpack_require__(36060);
var MainFooter_module_default = /*#__PURE__*/__webpack_require__.n(MainFooter_module);
;// CONCATENATED MODULE: ./src/components/pages/home/imgs/coinMarketCapLogo.png
/* harmony default export */ var coinMarketCapLogo = ({"src":"/_next/static/media/coinMarketCapLogo.8e897035.png","height":73,"width":330,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAOklEQVR4nGOMjIoJYWBgePz///+XjIyMfED2PyBmBPIZgPyvIAWeQIEHQIG/QAEuIBsEmIH8P0CaFQDhsRV04q8FGQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/components/pages/home/imgs/banxaLogo.png
/* harmony default export */ var banxaLogo = ({"src":"/_next/static/media/banxaLogo.c36ed14c.png","height":40,"width":178,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAQAAADPnVVmAAAAKklEQVR42mNIb0uzT3fPiMryTo3LNSj1Y0hpS01LKc2MSo1JjkoLL6sDAM5lDFsFHx8BAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/components/pages/home/imgs/tradingViewLogo.png
/* harmony default export */ var tradingViewLogo = ({"src":"/_next/static/media/tradingViewLogo.bada880e.png","height":52,"width":303,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAQAAABJCSfIAAAAGUlEQVR42mOISI6wjbCO8Ipwj/CLcI10AAArYgUBKl4+GgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":1});
;// CONCATENATED MODULE: ./src/components/pages/home/imgs/coinGeckoLogo.png
/* harmony default export */ var coinGeckoLogo = ({"src":"/_next/static/media/coinGeckoLogo.5876039a.png","height":67,"width":249,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAQAAADPnVVmAAAAKklEQVR42mNIepT0NF4hUCtUP9gkRCdEhyHsVtz9HAl/uVClENUQlRAVAMy8Cs8IlKiUAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/components/pages/home/imgs/yahooLogo.png
/* harmony default export */ var yahooLogo = ({"src":"/_next/static/media/yahooLogo.cd156708.png","height":61,"width":173,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAQAAAAEwYbDAAAAPElEQVR42mMIF44QiXWM9Y3mi5WMEYiNZYidHrs+9kDs1tjVsatil8ckMcQGxerH6ERJxWrHqsQaRPMAAKKuEFg8eMAiAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":3});
// EXTERNAL MODULE: ./src/layout/footer/LogoMarquee.module.scss
var LogoMarquee_module = __webpack_require__(98408);
var LogoMarquee_module_default = /*#__PURE__*/__webpack_require__.n(LogoMarquee_module);
;// CONCATENATED MODULE: ./src/layout/footer/LogoMarquee.js








function RotatingPart() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                alt: "CoinMarketCapLogo",
                src: coinMarketCapLogo,
                objectFit: "contain"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                alt: "BanxaLogo",
                src: banxaLogo,
                objectFit: "contain"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                alt: "TradingViewLogo",
                src: tradingViewLogo,
                objectFit: "contain"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                alt: "CoinGeckoLogo",
                src: coinGeckoLogo,
                objectFit: "contain"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                alt: "YahooLogo",
                src: yahooLogo,
                objectFit: "contain"
            })
        ]
    });
}
function LogoMarquee() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (LogoMarquee_module_default()).marqueeCon,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (LogoMarquee_module_default()).marquee,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (LogoMarquee_module_default()).rotateMe,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RotatingPart, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RotatingPart, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RotatingPart, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RotatingPart, {})
                ]
            })
        })
    });
}
/* harmony default export */ var footer_LogoMarquee = (LogoMarquee);

;// CONCATENATED MODULE: ./src/layout/footer/icons/ThreadsIcon.js

function ThreadsIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 21,
        height: 21,
        viewBox: "0 0 256 256",
        xmlSpace: "preserve",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            style: {
                stroke: "none",
                strokeWidth: 0,
                strokeDasharray: "none",
                strokeLinecap: "butt",
                strokeLinejoin: "miter",
                strokeMiterlimit: 10,
                fill: "none",
                fillRule: "nonzero",
                opacity: 1
            },
            transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M 45 0 L 45 0 C 20.147 0 0 20.147 0 45 v 0 c 0 24.853 20.147 45 45 45 h 0 c 24.853 0 45 -20.147 45 -45 v 0 C 90 20.147 69.853 0 45 0 z M 28.122 64.404 c 3.797 4.827 9.637 7.303 17.359 7.361 c 6.961 -0.051 11.567 -1.707 15.399 -5.536 c 4.374 -4.37 4.292 -9.73 2.893 -12.992 c -0.823 -1.919 -2.312 -3.515 -4.322 -4.728 c -0.49 3.648 -1.598 6.544 -3.351 8.778 c -2.308 2.942 -5.617 4.551 -9.834 4.783 C 43.073 62.245 40 61.474 37.614 59.9 c -2.822 -1.863 -4.473 -4.715 -4.65 -8.03 c -0.348 -6.535 4.836 -11.238 12.9 -11.703 c 2.863 -0.164 5.541 -0.035 8.017 0.386 c -0.329 -2.011 -0.993 -3.604 -1.985 -4.756 c -1.364 -1.583 -3.471 -2.396 -6.264 -2.413 c -0.026 0 -0.052 0 -0.078 0 c -2.242 0 -5.287 0.628 -7.227 3.571 l -4.665 -3.2 c 2.597 -3.941 6.816 -6.106 11.89 -6.106 c 0.038 0 0.077 0 0.115 0 c 8.482 0.054 13.533 5.347 14.035 14.591 c 0.288 0.124 0.573 0.253 0.852 0.387 c 3.958 1.898 6.852 4.773 8.37 8.312 c 2.116 4.935 2.309 12.975 -4.111 19.388 C 59.907 75.229 53.95 77.441 45.5 77.5 h -0.038 c -9.505 -0.066 -16.814 -3.264 -21.724 -9.506 c -4.369 -5.554 -6.623 -13.283 -6.699 -22.971 l 0 -0.023 l 0 -0.023 c 0.076 -9.688 2.33 -17.417 6.699 -22.971 c 4.91 -6.242 12.219 -9.44 21.724 -9.506 H 45.5 c 9.524 0.066 16.916 3.252 21.97 9.47 c 2.494 3.068 4.326 6.767 5.491 11.06 l -5.466 1.458 c -0.961 -3.487 -2.418 -6.479 -4.351 -8.857 c -3.942 -4.85 -9.884 -7.339 -17.662 -7.396 c -7.722 0.057 -13.562 2.534 -17.359 7.361 c -3.556 4.52 -5.393 11.048 -5.462 19.404 C 22.729 53.356 24.567 59.884 28.122 64.404 z",
                    style: {
                        stroke: "none",
                        strokeWidth: 1,
                        strokeDasharray: "none",
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 10,
                        fill: "currentColor",
                        fillRule: "nonzero",
                        opacity: 1
                    },
                    transform: " matrix(1 0 0 1 0 0) ",
                    strokeLinecap: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M 46.181 45.893 c -5.811 0.335 -7.738 3.146 -7.604 5.666 c 0.181 3.398 3.853 4.984 7.387 4.785 c 3.46 -0.19 7.388 -1.548 8.058 -9.91 c -1.795 -0.392 -3.77 -0.598 -5.881 -0.598 C 47.5 45.836 46.847 45.854 46.181 45.893 z",
                    style: {
                        stroke: "none",
                        strokeWidth: 1,
                        strokeDasharray: "none",
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 10,
                        fill: "rgb(0,0,0)",
                        fillRule: "nonzero",
                        opacity: 1
                    },
                    transform: " matrix(1 0 0 1 0 0) ",
                    strokeLinecap: "round"
                })
            ]
        })
    });
}
/* harmony default export */ var icons_ThreadsIcon = (ThreadsIcon);

;// CONCATENATED MODULE: ./src/layout/footer/icons/CmcIcon.js

function CmcIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        viewBox: "0 0 76.52 77.67",
        xmlns: "http://www.w3.org/2000/svg",
        width: 21,
        height: 21,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "m66.54 46.41a4.09 4.09 0 0 1 -4.17.28c-1.54-.87-2.37-2.91-2.37-5.69v-8.52c0-4.09-1.62-7-4.33-7.79-4.58-1.34-8 4.27-9.32 6.38l-8.1 13.11v-16c-.09-3.69-1.29-5.9-3.56-6.56-1.5-.44-3.75-.26-5.94 3.08l-18.11 29.07a32 32 0 0 1 -3.64-14.94c0-17.52 14-31.77 31.25-31.77s31.3 14.25 31.3 31.77v.09s0 .06 0 .09c.17 3.39-.93 6.09-3 7.4zm10-7.57v-.17c-.14-21.35-17.26-38.67-38.29-38.67s-38.25 17.42-38.25 38.83 17.16 38.84 38.25 38.84a37.81 37.81 0 0 0 26-10.36 3.56 3.56 0 0 0 .18-5 3.43 3.43 0 0 0 -4.86-.23 30.93 30.93 0 0 1 -44.57-2.08l16.3-26.2v12.09c0 5.81 2.25 7.69 4.14 8.24s4.78.17 7.81-4.75l9-14.57c.28-.47.55-.87.79-1.22v7.41c0 5.43 2.18 9.77 6 11.91a11 11 0 0 0 11.21-.45c4.2-2.73 6.49-7.67 6.25-13.62z",
            fill: "currentColor"
        })
    });
}
/* harmony default export */ var icons_CmcIcon = (CmcIcon);

;// CONCATENATED MODULE: ./src/layout/footer/MainFooter.js
/* eslint-disable react/no-unstable-nested-components */ 





















var tgUrl = {
    zh: "https://t.me/BitopExchange_official/1",
    en: "https://t.me/BitopExchange_official/132790"
};
function Footer() {
    var routeFunction = function routeFunction(route) {
        switch(route){
            case "login":
                if ((0,common/* getPlatform */.Xf)() === "pad" || (0,common/* getPlatform */.Xf)() === "pc") {
                    (0,sessionPass/* default */.ZP)("/login");
                } else {
                    (0,sessionPass/* default */.ZP)("".concat(phrase, "/login/login").concat(referral));
                }
                break;
            case "announcement":
                if ((0,common/* getPlatform */.Xf)() === "pad" || (0,common/* getPlatform */.Xf)() === "pc") {
                    router.push("/news/announcement");
                } else {
                    router.push("/news/announcement");
                }
                break;
            case "helpCenter":
                if ((0,common/* getPlatform */.Xf)() === "pad" || (0,common/* getPlatform */.Xf)() === "pc") {
                    router.push("/helpCenter/beginnerGuide");
                } else {
                    router.push("/helpCenter/beginnerGuide");
                }
                break;
            case "download":
                if ((0,common/* getPlatform */.Xf)() === "pad" || (0,common/* getPlatform */.Xf)() === "pc") {
                    router.push("/download");
                } else {
                    router.push("/download");
                }
                break;
            default:
                if ((0,common/* getPlatform */.Xf)() === "pad" || (0,common/* getPlatform */.Xf)() === "pc") {
                    (0,sessionPass/* default */.ZP)("/trade/deal/BTCUSDT");
                } else {
                    (0,sessionPass/* default */.ZP)("".concat(phrase).concat(referral));
                }
        }
    };
    var MobileFooter = function MobileFooter() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (MainFooter_module_default()).mobile,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (MainFooter_module_default()).routesCon,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("details", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("summary", {
                                className: (MainFooter_module_default()).route,
                                children: t("aboutUs.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (MainFooter_module_default()).subroute,
                                onClick: function() {
                                    return routeFunction("announcement");
                                },
                                onKeyUp: function(e) {
                                    if (e.key === "Enter" || e.key === "Space") routeFunction("announcement");
                                },
                                role: "button",
                                tabIndex: 0,
                                children: t("aboutUs.content.announcements")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (MainFooter_module_default()).subroute,
                                onClick: function() {
                                    return routeFunction("helpCenter");
                                },
                                onKeyUp: function(e) {
                                    if (e.key === "Enter" || e.key === "Space") routeFunction("helpCenter");
                                },
                                role: "button",
                                tabIndex: 0,
                                children: t("support.content.helpCenter")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (MainFooter_module_default()).subroute,
                                onClick: function() {
                                    return routeFunction("download");
                                },
                                onKeyUp: function(e) {
                                    if (e.key === "Enter" || e.key === "Space") routeFunction("download");
                                },
                                role: "button",
                                tabIndex: 0,
                                children: t2("newHeader.download.title")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (MainFooter_module_default()).community,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (MainFooter_module_default()).title,
                                children: t("community.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (MainFooter_module_default()).socialButtons,
                                children: renderSocialButtons
                            })
                        ]
                    })
                ]
            })
        });
    };
    var DesktopFooter = function DesktopFooter() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (MainFooter_module_default()).desktop,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: (MainFooter_module_default()).companyInfo,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (MainFooter_module_default()).aboutUs,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (MainFooter_module_default()).title,
                                children: t("aboutUs.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    className: (MainFooter_module_default()).linkButton,
                                    href: "/legalCenter/termsOfService",
                                    children: t("aboutUs.content.termOfService")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    className: (MainFooter_module_default()).linkButton,
                                    href: "/legalCenter/privacyPolicy",
                                    children: t("aboutUs.content.privacy")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    className: (MainFooter_module_default()).linkButton,
                                    href: "/legalCenter/riskNotice",
                                    children: t("aboutUs.content.riskWarning")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    className: (MainFooter_module_default()).linkButton,
                                    href: "/news/announcement",
                                    children: t("aboutUs.content.announcements")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    className: (MainFooter_module_default()).linkButton,
                                    href: "/news/stories",
                                    children: t("aboutUs.content.news")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (MainFooter_module_default()).products,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (MainFooter_module_default()).title,
                                children: t("products.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: (MainFooter_module_default()).linkButton,
                                    onKeyDown: function() {
                                        window.location.href = user ? "/trade/spot/BTCUSDT_CC" : "".concat(langUrl, "/trade/spotV2/BTCUSDT_CC");
                                    },
                                    onClick: function() {
                                        window.location.href = user ? "/trade/spot/BTCUSDT_CC" : "".concat(langUrl, "/trade/spotV2/BTCUSDT_CC");
                                    },
                                    tabIndex: 0,
                                    children: t("products.content.spot")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: (MainFooter_module_default()).linkButton,
                                    onKeyDown: function() {
                                        window.location.href = user ? "/trade/deal/BTCUSDT" : "".concat(langUrl, "/trade/margin/BTCUSDT");
                                    },
                                    onClick: function() {
                                        window.location.href = user ? "/trade/deal/BTCUSDT" : "".concat(langUrl, "/trade/margin/BTCUSDT");
                                    },
                                    tabIndex: 0,
                                    children: t("products.content.margin")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: (MainFooter_module_default()).linkButton,
                                    onKeyDown: function() {
                                        window.location.href = user ? "/trade/game/BTCUSDT" : "".concat(langUrl, "/trade/bitcast/BTCUSDT");
                                    },
                                    onClick: function() {
                                        window.location.href = user ? "/trade/game/BTCUSDT" : "".concat(langUrl, "/trade/bitcast/BTCUSDT");
                                    },
                                    tabIndex: 0,
                                    children: t("products.content.bitcast")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (MainFooter_module_default()).service,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (MainFooter_module_default()).title,
                                children: t("service.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: (MainFooter_module_default()).linkButton,
                                    onKeyDown: handleRedirectTo,
                                    onClick: handleRedirectTo,
                                    tabIndex: 0,
                                    "data-path": getPath(),
                                    children: t("service.content.buyCrypto")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: (MainFooter_module_default()).linkButton,
                                    onKeyDown: handleRedirectTo,
                                    onClick: handleRedirectTo,
                                    tabIndex: 0,
                                    "data-path": user ? "/trade/agent/agent" : "/login",
                                    children: t("service.content.referral")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: (MainFooter_module_default()).linkButton,
                                    onKeyDown: handleRedirectTo,
                                    onClick: handleRedirectTo,
                                    tabIndex: 0,
                                    "data-path": user ? "/trade/fastChange" : "/login",
                                    children: t("service.content.exchange")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: (MainFooter_module_default()).linkButton,
                                    onKeyDown: handleRedirectTo,
                                    onClick: handleRedirectTo,
                                    tabIndex: 0,
                                    "data-path": "/trade/follow",
                                    children: t("service.content.copyTrading")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (MainFooter_module_default()).support,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (MainFooter_module_default()).title,
                                children: t("support.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                role: "presentation",
                                onKeyUp: customerService,
                                className: (MainFooter_module_default()).linkButton,
                                onClick: customerService,
                                children: t("support.content.chatSupport")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    className: (MainFooter_module_default()).linkButton,
                                    href: "".concat(langUrl, "/helpCenter"),
                                    children: t("support.content.helpCenter")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                role: "presentation",
                                onKeyUp: customerService,
                                className: (MainFooter_module_default()).linkButton,
                                onClick: customerService,
                                children: t("support.content.feedback")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    className: (MainFooter_module_default()).linkButton,
                                    href: "".concat(langUrl, "/official-verification"),
                                    children: t("support.content.officialVerification")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (MainFooter_module_default()).community,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (MainFooter_module_default()).title,
                                children: t("community.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (MainFooter_module_default()).socialButtons,
                                children: renderSocialButtons
                            })
                        ]
                    })
                ]
            })
        });
    };
    var router = (0,next_router.useRouter)();
    var ref = (0,esm/* useTranslation */.$G)("common", {
        keyPrefix: "footer"
    }), t = ref.t, i18n = ref.i18n;
    var ref1 = (0,esm/* useTranslation */.$G)("common"), t2 = ref1.t;
    var user = (0,store/* useStore */.oR)().auth.user;
    var ref2 = (0,Modal_Portal/* default */.Z)({
        closeOnOutSide: true
    }), Portal = ref2.Portal, PortalOpen = ref2.PortalOpen, PortalClose = ref2.PortalClose;
    var ref3 = (0,useH5StringBuilder/* default */.Z)(), phrase = ref3.phrase, referral = ref3.referral;
    var renderSocialButtons = (0,react.useMemo)(function() {
        var socialList = [
            {
                name: "telegram",
                icon: icons_TgIcon,
                url: tgUrl[i18n.language]
            },
            {
                name: "CoinMarketCap",
                icon: icons_CmcIcon,
                url: "https://coinmarketcap.com/community/profile/Bitop_Exchange/"
            },
            {
                name: "linkedin",
                icon: icons_LiIcon,
                url: "https://www.linkedin.com/company/bitop-cryptocurrency-exchange/about/"
            },
            {
                name: "instagram",
                icon: icons_IgIcon,
                url: "https://www.instagram.com/bitop_exchange/"
            },
            {
                name: "Threads",
                icon: icons_ThreadsIcon,
                url: "https://www.threads.net/@bitop_exchange/"
            },
            // {
            //   name: 'discord',
            //   icon: DcIcon,
            //   url: 'https://discord.gg/8wRECA3R',
            // },
            {
                name: "medium",
                icon: icons_MdIcon,
                url: "https://medium.com/@bitop/"
            },
            {
                name: "linktree",
                icon: icons_LtIcon,
                url: "https://linktr.ee/bitopexchange/"
            },
            {
                name: "twitter",
                icon: TwIcon,
                url: "https://twitter.com/bitop_exchange/"
            },
            {
                name: "facebook",
                icon: icons_FbIcon,
                url: "https://www.facebook.com/BitopGlobal/"
            }, 
        ];
        return socialList.map(function(social) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                onClick: function(e) {
                    e.preventDefault();
                    window.open(social.url, "_blank").focus();
                },
                href: social.url,
                type: "button",
                "aria-label": "".concat(social.name, " link"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(social.icon, {})
            }, social.name);
        });
    }, [
        i18n
    ]);
    var handleRedirectTo = (0,react.useCallback)(function(e) {
        var dataset = e.currentTarget.dataset;
        if (dataset.path === "/login") return PortalOpen();
        return (0,sessionPass/* default */.ZP)(dataset.path);
    }, []);
    var getPath = (0,react.useCallback)(function() {
        var path = "";
        if (user) {
            path = "/c2c";
        } else {
            path = "/login";
        }
        return path;
    }, [
        i18n,
        user
    ]);
    var customerService = (0,react.useCallback)(function() {
        // let csUrl = 'https://chat.bitopeasy.com?eid=5de2dee8fdc42d3bd5c232c58a41bde1';
        // if (user) {
        //   const { userId, username } = user;
        //   csUrl += `&showUserId=${userId || ''}&userName=${window.encodeURIComponent(username) || '游客'}`;
        // }
        // window.open(csUrl, 'mywin', 'width=500,height=610');
        (0,common/* openZendesk */.xh)();
    }, [
        user
    ]);
    var langUrl = "";
    if (i18n.language === "en") {
        langUrl = "/en";
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: (MainFooter_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                className: (MainFooter_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                        className: (MainFooter_module_default()).logosContent,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_LogoMarquee, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopFooter, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileFooter, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                        className: (MainFooter_module_default()).divider
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: (MainFooter_module_default()).copyright,
                        children: t("copyright")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Portal, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ServicePlatformChoice/* default */.Z, {
                    cross: true,
                    closeFunc: PortalClose,
                    width: "10%"
                })
            })
        ]
    });
}
/* harmony default export */ var MainFooter = (Footer);

;// CONCATENATED MODULE: ./src/layout/footer/index.js
/* eslint-disable import/prefer-default-export */ 

// EXTERNAL MODULE: ./src/layout/MainLayout.module.scss
var MainLayout_module = __webpack_require__(33714);
var MainLayout_module_default = /*#__PURE__*/__webpack_require__.n(MainLayout_module);
;// CONCATENATED MODULE: ./src/layout/MainLayout.js
















// import { CustomerService } from '@/components/pages/home/imgs/svgs';



var allowDomains = [
    "/eventCenter",
    "/markets",
    "/quizPool",
    "/trade",
    "/news",
    "/helpCenter",
    "/helpCenterApp",
    "/legalCenter",
    "/download",
    "/official-verification",
    "/cs",
    "/", 
];
function MainLayout(_param) {
    var children = _param.children, className = _param.className, headProps = _param.headProps, hideCustomerService = _param.hideCustomerService, hideFooter = _param.hideFooter, hideHeader = _param.hideHeader, hideZendesk = _param.hideZendesk, pageClassName = _param.pageClassName, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className",
        "headProps",
        "hideCustomerService",
        "hideFooter",
        "hideHeader",
        "hideZendesk",
        "pageClassName"
    ]);
    var title = headProps.title, _description = headProps.description, description = _description === void 0 ? "" : _description, _canonical = headProps.canonical, canonical = _canonical === void 0 ? "https://www.bitop.com" : _canonical, _keyword = headProps.keyword, keyword = _keyword === void 0 ? "bitop,Bitop,exchange,交易所" : _keyword;
    var ref = (0,esm/* useTranslation */.$G)("common"), t = ref.t, i18n = ref.i18n;
    var user = (0,store/* useStore */.oR)().auth.user;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,react.useState)(true), loading = ref1[0], setLoading = ref1[1];
    // const customerService = useCallback(() => {
    //   let csUrl = 'https://chat.bitopeasy.com?eid=5de2dee8fdc42d3bd5c232c58a41bde1';
    //   if (user) {
    //     const { userId, username } = user;
    //     csUrl += `&showUserId=${userId || ''}&userName=${window.encodeURIComponent(username) || '游客'}`;
    //   }
    //   window.open(csUrl, 'mywin', 'width=500,height=610');
    // }, [user]);
    (0,react.useEffect)(function() {
        var handleRouteChange = function() {
            // console.log('popstate effect', window.history.state)
            if (window.history.state.as !== window.history.state.url) {
                router.push(window.history.state.as); // Reload only when going back，nextJs + browser back/fwd btn toolbar interaction problem
            }
        };
        window.addEventListener("popstate", handleRouteChange);
        var localStorage = window.localStorage;
        var lang = localStorage.getItem("lang");
        if (appConfig/* localeMap */.h$[lang] !== i18n) {
            router.replace(router.asPath, router.asPath, {
                locale: appConfig/* localeMap */.h$[lang]
            }).catch(function() {});
        }
        if (hideZendesk) {
            (0,common/* closeZendesk */.V1)();
        }
        return function() {
            return window.removeEventListener("popstate", handleRouteChange);
        };
    }, []);
    (0,react.useEffect)(function() {
        setLoading(true);
        try {
            var url = router.route.split("/");
            if (!allowDomains.includes("/".concat(url[1])) && user) {
                (0,sessionPass/* default */.ZP)("/trade/deal/BTCUSDT");
            }
        // eslint-disable-next-line no-empty
        } catch (e) {} finally{
            setLoading(false);
        }
    }, [
        router,
        user
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (MainLayout_module_default()).loading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: title || t("defaultTitle")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: title || t("defaultTitle")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: title || t("defaultTitle")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:site_name",
                        content: title || t("defaultTitle")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: description || t("defaultDescription")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: description || t("defaultDescription")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: description || t("defaultDescription")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: canonical || "https://www.bitop.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: keyword || t("defaultKeywords")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                className: classnames_default()((MainLayout_module_default()).container, (0,_define_property/* default */.Z)({}, className, !!className))
            }, props), {
                children: [
                    !hideHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                        className: (MainLayout_module_default()).header,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(header_MainHeader, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                        className: classnames_default()((MainLayout_module_default()).page, (0,_define_property/* default */.Z)({}, pageClassName, !!pageClassName)),
                        children: children
                    }),
                    !hideFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                        className: (MainLayout_module_default()).footer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainFooter, {})
                    })
                ]
            }))
        ]
    });
}
MainLayout.propTypes = {
    children: (prop_types_default()).node.isRequired,
    className: (prop_types_default()).string,
    headProps: prop_types_default().shape({
        title: (prop_types_default()).string,
        description: (prop_types_default()).string,
        canonical: (prop_types_default()).string,
        keyword: (prop_types_default()).string
    }),
    hideCustomerService: (prop_types_default()).bool,
    hideFooter: (prop_types_default()).bool,
    hideHeader: (prop_types_default()).bool,
    hideZendesk: (prop_types_default()).bool,
    pageClassName: (prop_types_default()).string
};
MainLayout.defaultProps = {
    className: "",
    headProps: {
        title: ""
    },
    hideCustomerService: false,
    hideHeader: false,
    hideFooter: false,
    hideZendesk: false,
    pageClassName: ""
};
/* harmony default export */ var layout_MainLayout = ((0,mobxreact_esm/* observer */.Pi)(MainLayout));


/***/ }),

/***/ 40822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function BitopIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: "65.295",
        height: "33.295",
        viewBox: "0 0 65.295 33.295",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                    id: "linearbitop",
                    y1: "0.5",
                    x2: "1",
                    y2: "0.5",
                    gradientUnits: "objectBoundingBox",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                            offset: "0",
                            stopColor: "#00a5ff"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                            offset: "0.3",
                            stopColor: "#00cbfd"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                            offset: "1",
                            stopColor: "#00f2ed"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                id: "Group_2",
                "data-name": "Group 2",
                transform: "translate(0.5 0.5)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    id: "Union_45",
                    "data-name": "Union 45",
                    d: "M48.893,32.3V16.1a7.657,7.657,0,0,1,.6-3,7.67,7.67,0,0,1,4.1-4.1,7.758,7.758,0,0,1,5.992,0,7.668,7.668,0,0,1,4.1,4.1,7.767,7.767,0,0,1,0,5.992,7.671,7.671,0,0,1-4.1,4.1,7.787,7.787,0,0,1-5.6.157,7.743,7.743,0,0,1-2.214-1.24V32.3Zm5.824-20.631a4.887,4.887,0,0,0-2.563,2.563,4.913,4.913,0,0,0,0,3.753,4.881,4.881,0,0,0,2.563,2.563A4.8,4.8,0,0,0,60,19.509a5.067,5.067,0,0,0,1.034-1.529,4.913,4.913,0,0,0,0-3.753A5.057,5.057,0,0,0,60,12.7a4.853,4.853,0,0,0-5.283-1.035ZM36.3,23.2a7.672,7.672,0,0,1-4.1-4.1,7.767,7.767,0,0,1,0-5.992,7.67,7.67,0,0,1,4.1-4.1,7.758,7.758,0,0,1,5.992,0,7.67,7.67,0,0,1,4.1,4.1,7.767,7.767,0,0,1,0,5.992,7.672,7.672,0,0,1-4.1,4.1,7.759,7.759,0,0,1-5.992,0Zm1.119-11.538a4.844,4.844,0,0,0-2.562,6.317,5.039,5.039,0,0,0,1.034,1.528,4.861,4.861,0,0,0,1.528,1.034,4.807,4.807,0,0,0,1.877.373,4.865,4.865,0,0,0,1.877-.373A5.042,5.042,0,0,0,42.7,19.509a4.882,4.882,0,0,0,1.023-1.528A4.834,4.834,0,0,0,42.7,12.7a5.058,5.058,0,0,0-1.528-1.035,4.866,4.866,0,0,0-1.877-.373A4.808,4.808,0,0,0,37.414,11.664ZM4.7,23.2A7.672,7.672,0,0,1,.6,19.1a7.658,7.658,0,0,1-.6-3V0H2.888V10.088A7.731,7.731,0,0,1,10.7,9.005a7.663,7.663,0,0,1,4.1,4.1,7.759,7.759,0,0,1,0,5.992,7.666,7.666,0,0,1-4.1,4.1,7.759,7.759,0,0,1-5.992,0ZM5.823,11.664A4.863,4.863,0,0,0,4.3,12.7a5.044,5.044,0,0,0-1.034,1.528,4.915,4.915,0,0,0,0,3.754A5.061,5.061,0,0,0,4.3,19.509a4.851,4.851,0,0,0,5.283,1.034A5.035,5.035,0,0,0,11.1,19.509a4.879,4.879,0,0,0,1.023-1.528,4.775,4.775,0,0,0,0-3.754A4.863,4.863,0,0,0,11.1,12.7a5.05,5.05,0,0,0-1.527-1.035,4.917,4.917,0,0,0-3.755,0ZM25.392,23.323V14.949l-1.167.674-1.443-2.5,2.611-1.5V6H28.28V9.944l1.167-.674,1.443,2.5-2.611,1.5V23.323Zm-7.489,0V9.848H20.79V23.323Zm.252-16.135a1.684,1.684,0,0,1,0-2.382A1.685,1.685,0,0,1,21.031,6a1.685,1.685,0,0,1-2.876,1.191Z",
                    transform: "translate(0 0)",
                    stroke: "rgba(0,0,0,0)",
                    strokeWidth: "1",
                    fill: "url(#linearbitop)"
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (BitopIcon);


/***/ }),

/***/ 65946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bo": function() { return /* binding */ usePrizeList; },
/* harmony export */   "Ro": function() { return /* binding */ useBoxList; },
/* harmony export */   "UW": function() { return /* binding */ useAssetList; },
/* harmony export */   "aD": function() { return /* binding */ usePoolInfo; },
/* harmony export */   "o6": function() { return /* binding */ useDrawnBoxList; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useRequest__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16314);


var requestConfig = {
    useAssetList: "/api/user/asset/list",
    usePoolInfo: "/api/quizPool/v2/poolInfo",
    usePrizeList: "/api/quizPool/v2/prize/list",
    useDrawnBoxList: "/api/quizPool/v2/box/list/1",
    useBoxList: "/api/quizPool/v2/box/page"
};
function useAssetList() {
    var ref = (0,_useRequest__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        url: requestConfig.useAssetList
    }), data = ref.data, error = ref.error, mutate = ref.mutate;
    var result = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        if (error) {
            // eslint-disable-next-line no-console
            console.error(error);
            return {
                done: true,
                error: error
            };
        }
        if (data) {
            return {
                assetList: data,
                mutateAL: mutate
            };
        }
        return {};
    }, [
        data,
        error
    ]);
    return result;
}
function usePoolInfo() {
    var ref = (0,_useRequest__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        url: requestConfig.usePoolInfo
    }), data = ref.data, error = ref.error, mutate = ref.mutate;
    var result = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        if (error) {
            // eslint-disable-next-line no-console
            console.error(error);
            return {
                done: true,
                error: error
            };
        }
        if (data) {
            return {
                poolInfo: data.data,
                mutatePI: mutate
            };
        }
        return {};
    }, [
        data,
        error
    ]);
    return result;
}
function usePrizeList(param) {
    var quizPoolCode = param.quizPoolCode;
    var ref = (0,_useRequest__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        url: "".concat(requestConfig.usePrizeList, "?quizPoolCode=").concat(quizPoolCode)
    }), data = ref.data, error = ref.error;
    var result = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        if (error) {
            // eslint-disable-next-line no-console
            console.error(error);
            return {
                done: true,
                error: error
            };
        }
        if (data) {
            return {
                data: data
            };
        }
        return {};
    }, [
        data,
        error
    ]);
    return result;
}
function useDrawnBoxList(param) {
    var quizPoolCode = param.quizPoolCode;
    var ref = (0,_useRequest__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        url: "".concat(requestConfig.useDrawnBoxList, "?quizPoolCode=").concat(quizPoolCode)
    }), data = ref.data, error = ref.error, mutate = ref.mutate;
    var result = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        if (error) {
            // eslint-disable-next-line no-console
            console.error(error);
            return {
                done: true,
                error: error
            };
        }
        if (data) {
            var ref;
            return {
                dataDBL: data.data,
                totalDBL: (ref = data.data) === null || ref === void 0 ? void 0 : ref.length,
                mutateDBL: mutate
            };
        }
        return {};
    }, [
        data,
        error
    ]);
    return result;
}
function useBoxList(param) {
    var quizPoolCode = param.quizPoolCode, page = param.page, rows = param.rows;
    var ref = (0,_useRequest__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        url: "".concat(requestConfig.useBoxList, "?quizPoolCode=").concat(quizPoolCode, "&page=").concat(page, "&rows=").concat(rows)
    }), data = ref.data, error = ref.error, mutate = ref.mutate;
    var result = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        if (error) {
            // eslint-disable-next-line no-console
            console.error(error);
            return {
                done: true,
                error: error
            };
        }
        if (data) {
            return {
                total: data.total,
                data: data.data,
                mutate: mutate
            };
        }
        return {};
    }, [
        data,
        error
    ]);
    return result;
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    useAssetList: useAssetList,
    usePoolInfo: usePoolInfo,
    usePrizeList: usePrizeList,
    useDrawnBoxList: useDrawnBoxList,
    useBoxList: useBoxList
});


/***/ }),

/***/ 82807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28677);
/* harmony import */ var _functions_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18942);


function useH5StringBuilder() {
    if (false) {}
    var i18n = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)("common").i18n;
    // e.g. https://www.bitop.com/en?ru=631915146406936576&f=BTITart
    var hostname = window.location.hostname.split(".").slice(-2).join(".");
    var phrase = "".concat(window.location.protocol, "//m.").concat(hostname).concat(i18n.language === "en" ? "/eng" : "/zh");
    var RUF = (0,_functions_common__WEBPACK_IMPORTED_MODULE_1__/* .referralRUF */ .$)();
    return {
        phrase: phrase,
        referral: RUF && RUF
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useH5StringBuilder);


/***/ }),

/***/ 16314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useRequest; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8100);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28677);
/* harmony import */ var _functions_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18942);
/* harmony import */ var _api_restful__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19200);







function useRequest(request) {
    var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var fallbackData = _param.fallbackData, config = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "fallbackData"
    ]);
    var i18n = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)().i18n;
    var defaultRequest = {
        method: "get",
        headers: {
            "Accept-Language": i18n.language === "zh" ? "zh-CN" : "en-US"
        }
    };
    var combinedRequest = (0,_functions_common__WEBPACK_IMPORTED_MODULE_2__/* .mergeDeep */ .Ee)(defaultRequest, request);
    var ref = (0,swr__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(combinedRequest && JSON.stringify(combinedRequest), function() {
        return _api_restful__WEBPACK_IMPORTED_MODULE_3__/* ["default"].REQUEST */ .Z.REQUEST(combinedRequest || {}).then(function(response) {
            if (response.data.code === 403) {
                var err = new Error("Frequent request error");
                err.error = response.data;
                throw err;
            }
            return response.data;
        });
    }, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        dedupingInterval: 1000,
        errorRetryInterval: 2000
    }, config), {
        headers: {
            "Accept-Language": "zh-CN"
        },
        fallbackData: fallbackData && {
            status: 200,
            statusText: "InitialData",
            headers: {},
            data: fallbackData
        }
    })), data = ref.data, error = ref.error, isValidating = ref.isValidating, mutate = ref.mutate;
    return {
        data: data,
        error: error,
        isLoading: isValidating,
        mutate: mutate
    };
}


/***/ }),

/***/ 45432:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"default":"Button_default__g4rec","plane":"Button_plane__3EwuZ","empty":"Button_empty__Eqx11"};

/***/ }),

/***/ 32710:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"showCenter":"Tooltip_showCenter__svYNr","showLeft":"Tooltip_showLeft__PnFLG","showRight":"Tooltip_showRight__IvGxW","container":"Tooltip_container__NKjZ_","tooltip":"Tooltip_tooltip__AnB_W","special":"Tooltip_special__SHxJG","feesDetailsDropDown":"Tooltip_feesDetailsDropDown__pJWr_"};

/***/ }),

/***/ 26022:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Portal_overlay__Blmb6","modal":"Portal_modal__S1Ydp","modalShow":"Portal_modalShow__Vzhbk","content":"Portal_content__qQNA5","contentShow":"Portal_contentShow__hCLfo","footer":"Portal_footer__8OCeK","footerShow":"Portal_footerShow__JtnLh","noScroll":"Portal_noScroll__kSBHQ"};

/***/ }),

/***/ 86786:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root_include_ru":"ServicePlatformChoice_root_include_ru___Ty98","footer":"ServicePlatformChoice_footer__cO6wb","container":"ServicePlatformChoice_container__HnOum","cross":"ServicePlatformChoice_cross__1Ssxf","title":"ServicePlatformChoice_title__LNmd1","content":"ServicePlatformChoice_content__kCnsC","btn":"ServicePlatformChoice_btn__0ZKV0","btnFade":"ServicePlatformChoice_btnFade__QbZ7u"};

/***/ }),

/***/ 33714:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"MainLayout_container__uj_3d","header":"MainLayout_header__0VOmv","page":"MainLayout_page__u_AN_","footer":"MainLayout_footer__BGJv0","cs":"MainLayout_cs__n546C","loading":"MainLayout_loading__1XEpb"};

/***/ }),

/***/ 98408:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"marqueeCon":"LogoMarquee_marqueeCon__V9YXY","marquee":"LogoMarquee_marquee__IdJ2B","rotateMe":"LogoMarquee_rotateMe__FpsDZ"};

/***/ }),

/***/ 36060:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root_include_ru":"MainFooter_root_include_ru__VC6bx","footer":"MainFooter_footer__lUPgO","container":"MainFooter_container__H0bAd","content":"MainFooter_content__6THKV","logosContent":"MainFooter_logosContent__sDy6b","logos":"MainFooter_logos___PVlV","divider":"MainFooter_divider__R9DTg","mobile":"MainFooter_mobile__tKa76","companyInfo":"MainFooter_companyInfo__MIpLh","linkButton":"MainFooter_linkButton__8UDzC","title":"MainFooter_title__Ni910","aboutUs":"MainFooter_aboutUs___hCFu","products":"MainFooter_products__qFvil","service":"MainFooter_service__DB5BE","support":"MainFooter_support__kOR32","learn":"MainFooter_learn__96hSP","community":"MainFooter_community___17CH","socialButtons":"MainFooter_socialButtons__clKYq","copyright":"MainFooter_copyright__Gy_gl","routesCon":"MainFooter_routesCon__wSUHs","route":"MainFooter_route__Qx6VI","subroute":"MainFooter_subroute___0duy","desktop":"MainFooter_desktop__4zxlK"};

/***/ }),

/***/ 19804:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root_include_ru":"MainHeader_root_include_ru__zFrhZ","footer":"MainHeader_footer__MEhWL","container":"MainHeader_container__gRsND","desktop":"MainHeader_desktop__npEPE","mobile":"MainHeader_mobile__0QLQ9","nav":"MainHeader_nav__kByZb","navLinks":"MainHeader_navLinks__DazNh","btnCon":"MainHeader_btnCon__2hrVr","todayCP":"MainHeader_todayCP__uZZgy","tips":"MainHeader_tips__aQKyz","navDropDown":"MainHeader_navDropDown__Z7Wqe","dropDownSelector":"MainHeader_dropDownSelector__HXJpl","functionality":"MainHeader_functionality___05DM","loading":"MainHeader_loading__VshVX","user":"MainHeader_user__FxnXr","assetSelector":"MainHeader_assetSelector__xlDUz","historySelector":"MainHeader_historySelector__tIsOP","profileSelector":"MainHeader_profileSelector__pbK9w","login":"MainHeader_login__x0Ci4","register":"MainHeader_register__6_XaQ","downLoadInfo":"MainHeader_downLoadInfo__LPqMa","icons":"MainHeader_icons__i5MSA","downLoadDropDown":"MainHeader_downLoadDropDown__Nv_mr","qrcode":"MainHeader_qrcode__rhvrs","downLoadRight":"MainHeader_downLoadRight__Jxenk","firstRow":"MainHeader_firstRow__Soupk","secondRow":"MainHeader_secondRow__wBf14","thirdRow":"MainHeader_thirdRow__kHgyL","profile":"MainHeader_profile__IkEb8","account":"MainHeader_account__xP6DE","kycTag":"MainHeader_kycTag__QH_LT","unAuth":"MainHeader_unAuth__kMohk","basicAuth":"MainHeader_basicAuth__Rtr67","advanceAuth":"MainHeader_advanceAuth__nPVKu","id":"MainHeader_id__dNuS5","profileNav":"MainHeader_profileNav__NZLUj","languageSelector":"MainHeader_languageSelector__Nxyrs","overlay":"MainHeader_overlay__zIc38","open":"MainHeader_open__zH7_p","hamburgerMenu":"MainHeader_hamburgerMenu__5RJDd","menuAnimation":"MainHeader_menuAnimation__Kr5dx","cross":"MainHeader_cross__MD27N","btns":"MainHeader_btns__dREYE","routeCon":"MainHeader_routeCon__m2BUu","loggedIn":"MainHeader_loggedIn__oL0YL","route":"MainHeader_route__XPWO0","subroute":"MainHeader_subroute__myIGW"};

/***/ })

}]);